import * as i0 from '@angular/core';
import { Injectable, inject, Component, EventEmitter, Input, Output, forwardRef, Inject, Optional, Pipe, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@engineering11/ui-lib/e11-notifications';
import { E11NotificationsService, E11NotificationsModule } from '@engineering11/ui-lib/e11-notifications';
import { isNotNil } from '@engineering11/utility';
import * as i3$1 from '@engineering11/web-utilities';
import { BaseLocalStorageService, BaseSessionStorageService, WebUtilityModule } from '@engineering11/web-utilities';
import { filter, map, lastValueFrom, of, mergeMap, Subject, take, from } from 'rxjs';
import { RestApiClient } from '@engineering11/web-api-rest';
import { map as map$1, filter as filter$1, mergeMap as mergeMap$1, tap, catchError, distinctUntilChanged, switchMap } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
import { COLLECTIONS as COLLECTIONS$1, DEFAULT_USER_PREFERENCES, UserType } from '@engineering11/user-shared';
import * as i4$1 from '@engineering11/web-api-firebase';
import { CollectionRepository, FirestoreQueryBuilder, BaseFirestoreRepository } from '@engineering11/web-api-firebase';
import * as i1 from '@ngrx/component';
import { LetDirective } from '@ngrx/component';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@engineering11/ui-lib/e11-panel';
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel';
import * as i4 from '@engineering11/ui-lib/e11-switch';
import { E11SwitchModule } from '@engineering11/ui-lib/e11-switch';
import * as i12 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$3 from '@angular/forms';
import { FormControl, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import * as i1$2 from '@engineering11/web-api-error';
import { LOGGER_TOKEN, ERROR_TRACKER_TOKEN } from '@engineering11/web-api-error';
import * as i11 from '@engineering11/ui-lib/e11-input-errors';
import { E11FormValidationService, E11FormValidator, E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors';
import * as i6 from '@engineering11/ui-lib/e11-button';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import * as i8 from '@engineering11/ui-lib/e11-input';
import { E11InputModule } from '@engineering11/ui-lib/e11-input';
import * as i9 from '@engineering11/ui-lib/e11-select';
import { E11SelectModule } from '@engineering11/ui-lib/e11-select';
import * as i10 from '@engineering11/ui-lib/e11-multi-select';
import { E11MultiSelectModule } from '@engineering11/ui-lib/e11-multi-select';
import * as i1$5 from '@engineering11/ui-lib/e11-side-over';
import * as i5 from '@engineering11/ui-lib/e11-confirmation';
import { E11ConfirmationModule } from '@engineering11/ui-lib/e11-confirmation';
import algoliasearch from 'algoliasearch/lite';
import * as i3$2 from '@engineering11/ui-lib/e11-empty-state';
import { E11EmptyStateModule } from '@engineering11/ui-lib/e11-empty-state';
import * as i4$2 from '@engineering11/angular-instantsearch';
import { TypedBaseWidget, NgAisIndex, NgAisInstantSearch, NgAisHitsModule, NgAisSearchBoxModule, NgAisModule, NgAisInstantSearchModule } from '@engineering11/angular-instantsearch';
import * as i1$4 from '@engineering11/access-web';
import * as i5$1 from '@engineering11/maps-web';
import { AddressFormService, ViewAddressComponent } from '@engineering11/maps-web';
import * as i8$1 from '@engineering11/ui-lib/e11-form-builder';
import { e11FormFor, e11LayoutGroup, e11FormLayoutInlineGrid, e11FieldInputText, e11FieldInputPhone, E11DynamicFormModule } from '@engineering11/ui-lib/e11-form-builder';
import * as i9$1 from '@engineering11/ui-lib/e11-ui-utils';
import * as i4$3 from '@engineering11/ui-lib/e11-textarea';
import { E11TextareaModule } from '@engineering11/ui-lib/e11-textarea';
import * as i4$4 from '@angular/platform-browser';
import * as i6$1 from '@engineering11/ui-lib/e11-input-checkbox';
import { E11InputCheckboxModule } from '@engineering11/ui-lib/e11-input-checkbox';
import { createAction, props, createReducer, on, createFeature, createSelector } from '@ngrx/store';
import * as i1$6 from '@ngrx/effects';
import { createEffect, ofType } from '@ngrx/effects';
import Rollbar from 'rollbar';
import * as i8$2 from '@angular/router';
import { createEntityAdapter } from '@ngrx/entity';
import { E11LoaderDotsModule } from '@engineering11/ui-lib/e11-loader-dots';
import { E11PhoneNumberModule } from '@engineering11/ui-lib/e11-phone-number';

class BaseUserConfigProvider {
    getCurrentUserAppId() {
        return this.config.token$.pipe(filter(isNotNil), map((token) => {
            const user = jwt_decode(token);
            return user.appUserId;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseUserConfigProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseUserConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseUserConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class UserRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS$1.COLLECTION_USERS;
    }
    /**
     * In most cases this will be prohibited for non-admins
     * @param customerKey
     * @returns
     */
    getAllByCustomer(customerKey) {
        const queryRef = new FirestoreQueryBuilder().where('customerKey', '==', customerKey).build();
        const collectionPath = this.buildPath();
        return super._query(collectionPath, queryRef);
    }
    /**
     *
     *
     * @param {string} authId
     * @returns {Observable<IUser[]>}
     * @memberof UserRepository
     */
    getByAuthId(authId) {
        const queryRef = new FirestoreQueryBuilder().where('authId', '==', authId).build();
        const collectionPath = this.buildPath();
        return super._query(collectionPath, queryRef);
    }
    getAllActiveByCustomer(customerKey) {
        const queryRef = new FirestoreQueryBuilder().where('customerKey', '==', customerKey).where('isDisabled', '==', false).build();
        const collectionPath = this.buildPath();
        return super._query(collectionPath, queryRef);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class BusinessUserManagementRestService {
    constructor(configProvider, userRepository) {
        this.configProvider = configProvider;
        this.userRepository = userRepository;
        this.restClient = this.createRestClient();
    }
    getSearchKeyPackage() {
        return this.restClient.get('search-key/admin-package').pipe(map$1((item) => item.data));
    }
    async get(userId) {
        const response = lastValueFrom(this.restClient.get(`business-user/${userId}`));
        return (await response).data;
    }
    update(user) {
        return lastValueFrom(this.restClient.put(`business-user/${user.id}`, user));
    }
    disable(user) {
        return lastValueFrom(this.restClient.put(`business-user/${user.id}/disable`, {}));
    }
    enable(user) {
        return lastValueFrom(this.restClient.put(`business-user/${user.id}/enable`, {}));
    }
    getAllByCustomer(customerKey) {
        return this.userRepository.getAllByCustomer(customerKey);
    }
    getAllActiveByCustomer(customerKey) {
        return this.userRepository.getAllActiveByCustomer(customerKey);
    }
    createRestClient() {
        if (!this.configProvider.config.userBaseURL) {
            throw new Error('Missing configuration, userBaseURL is undefined. Configure User module with an IUserConfig model');
        }
        return new RestApiClient({
            baseUrl: this.configProvider.config.userBaseURL,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserManagementRestService, deps: [{ token: BaseUserConfigProvider }, { token: UserRepository }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserManagementRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserManagementRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseUserConfigProvider }, { type: UserRepository }] });

class PlatformAdminUserRestService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = this.createRestClient();
    }
    getSearchKeyPackage() {
        return this.restClient.get('search-key/platform-admin-package').pipe(map$1((item) => item.data));
    }
    async get(userId) {
        const response = lastValueFrom(this.restClient.get(`platform-admin/users/${userId}`));
        return (await response).data;
    }
    update(user) {
        return lastValueFrom(this.restClient.put(`platform-admin/users/${user.id}`, user));
    }
    disable(user) {
        return lastValueFrom(this.restClient.put(`platform-admin/users/${user.id}/disable`, {}));
    }
    enable(user) {
        return lastValueFrom(this.restClient.put(`platform-admin/users/${user.id}/enable`, {}));
    }
    createRestClient() {
        if (!this.configProvider.config.userBaseURL) {
            throw new Error('Missing configuration, userBaseURL is undefined. Configure User module with an IUserConfig model');
        }
        return new RestApiClient({
            baseUrl: this.configProvider.config.userBaseURL,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminUserRestService, deps: [{ token: BaseUserConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminUserRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminUserRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseUserConfigProvider }] });

class PrivacyPolicyRepository extends BaseFirestoreRepository {
    buildPath(id = '') {
        return `privacy_policy/${id}`;
    }
    getMostRecentPolicy() {
        const path = this.buildPath();
        const queryBuilder = new FirestoreQueryBuilder();
        queryBuilder.where('currentVersion', '==', true);
        return super._getAll(path, queryBuilder.build()).pipe(map$1((items) => items[0]));
    }
    set(model, ...ids) {
        throw new Error('Method not implemented.');
    }
    update(model, ...ids) {
        throw new Error('Method not implemented.');
    }
    delete(...ids) {
        throw new Error('Method not implemented.');
    }
    get(...ids) {
        throw new Error('Method not implemented.');
    }
    getValueChanges(...ids) {
        throw new Error('Method not implemented.');
    }
    getAll(...ids) {
        throw new Error('Method not implemented.');
    }
    getAllValueChanges(...ids) {
        throw new Error('Method not implemented.');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PrivacyPolicyRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PrivacyPolicyRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PrivacyPolicyRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class PrivacyPolicyService {
    constructor(termsRepository) {
        this.termsRepository = termsRepository;
    }
    getMostRecentPolicy() {
        return this.termsRepository.getMostRecentPolicy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PrivacyPolicyService, deps: [{ token: PrivacyPolicyRepository }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PrivacyPolicyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PrivacyPolicyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: PrivacyPolicyRepository }] });

var CONSTANTS;
(function (CONSTANTS) {
    CONSTANTS["USER_STATE_DISABLED"] = "Disabled";
    CONSTANTS["USER_STATE_INVITED"] = "Invited";
    CONSTANTS["USER_STATE_REGISTERED"] = "Registered";
    CONSTANTS["USER_STATE_UPLOADED"] = "Uploaded";
    CONSTANTS["ORIGIN_SOURCE_WEB"] = "web";
    CONSTANTS["ORIGIN_SOURCE_UPLOAD"] = "upload";
    CONSTANTS["SERVICE_ID"] = "user";
})(CONSTANTS || (CONSTANTS = {}));
var SEARCH_INDICES;
(function (SEARCH_INDICES) {
    SEARCH_INDICES["USER"] = "user";
})(SEARCH_INDICES || (SEARCH_INDICES = {}));
const COLLECTIONS = Object.freeze({
    TERMS_OF_USE: 'terms_of_use/',
});
const ERROR_HANDLING = {
    USER_NAME_MIN_LENGTH: 8,
    USER_NAME_MAX_LENGTH: 50,
    PASSWORD_MIN_LENGTH: 8,
    PASSWORD_MAX_LENGTH: 24,
    EMAIL_MIN_LENGTH: 7,
    EMAIL_MAX_LENGTH: 100,
    FIRST_NAME_MIN_LENGTH: 1,
    FIRST_NAME_MAX_LENGTH: 100,
    LAST_NAME_MIN_LENGTH: 1,
    LAST_NAME_MAX_LENGTH: 100,
    COMPANY_NAME_MIN_LENGTH: 5,
    COMPANY_NAME_MAX_LENGTH: 100,
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 20,
    ADDRESS_MIN_LENGTH: 4,
    ADDRESS_MAX_LENGTH: 100,
    STATE_REQUIRED_LENGTH: 2,
    ZIP_MIN_LENGTH: 5,
    ZIP_MAX_LENGTH: 12,
    COUNTRY_REQUIRED_LENGTH: 2,
};
var UserPermissions;
(function (UserPermissions) {
    UserPermissions["ManageEmployees"] = "user/manage-employees";
    UserPermissions["PlatformAdminEditAllUsers"] = "user/platform-admin-edit-all-users";
    UserPermissions["PlatformAdminViewAllUsers"] = "user/platform-admin-view-all-users";
    UserPermissions["PlatformAdminSearchAllUsers"] = "user/platform-admin-search-all-users";
    UserPermissions["ManageAllCustomerUsers"] = "user/manage-all-customer-users";
})(UserPermissions || (UserPermissions = {}));

class TermsRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.TERMS_OF_USE;
    }
    getMostRecentTerms() {
        const path = this.buildPath();
        const queryBuilder = new FirestoreQueryBuilder();
        queryBuilder.where('currentVersion', '==', true);
        return super._getAll(path, queryBuilder.build());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class TermsService {
    constructor(termsRepository) {
        this.termsRepository = termsRepository;
    }
    getMostRecentTerms() {
        return this.termsRepository.getMostRecentTerms();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsService, deps: [{ token: TermsRepository }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: TermsRepository }] });

class UserService {
    constructor(configProvider, userRepository) {
        this.configProvider = configProvider;
        this.userRepository = userRepository;
        this.restClient = this.createRestClient();
    }
    getUserById(appUserId) {
        return this.userRepository.get(appUserId);
    }
    getUserByIdValueChange(appUserId) {
        return this.userRepository.getValueChanges(appUserId);
    }
    update(user) {
        return lastValueFrom(this.restClient.put(`user/${user.id}`, user, { version: '2' }));
    }
    disable(user) {
        return lastValueFrom(this.restClient.put(`user/${user.id}/disable`, { version: '2' }));
    }
    enable(user) {
        return lastValueFrom(this.restClient.put(`user/${user.id}/enable`, { version: '2' }));
    }
    createRestClient() {
        if (!this.configProvider.config.userBaseURL) {
            throw new Error('Missing configuration, userBaseURL is undefined');
        }
        return new RestApiClient({
            baseUrl: this.configProvider.config.userBaseURL,
            token: this.configProvider.config.token$.pipe(filter(isNotNil)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserService, deps: [{ token: BaseUserConfigProvider }, { token: UserRepository }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BaseUserConfigProvider }, { type: UserRepository }] });

class UserPreferencesService {
    constructor(userService) {
        this.userService = userService;
    }
    /**
     * @param user a user id or an Observable of a user if one already exists.
     * If a non value changes observable is passed in then the method will obviously not return preferences as they are updated
     */
    getUserPreferencesValueChanges(user) {
        let userObservable;
        if (typeof user === 'string') {
            userObservable = this.userService.getUserByIdValueChange(user);
        }
        else {
            userObservable = user;
        }
        return userObservable.pipe(map$1((userOutput) => {
            if (!userOutput) {
                return userOutput;
            }
            const preferences = userOutput.userPreferences ?? DEFAULT_USER_PREFERENCES;
            return { ...DEFAULT_USER_PREFERENCES, ...preferences };
        }));
    }
    setUserPreference(preference, value, user) {
        if (!user.userPreferences) {
            user.userPreferences = {};
        }
        user.userPreferences[preference] = value;
        return this.userService.update(user);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserPreferencesService, deps: [{ token: UserService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserPreferencesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserPreferencesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: UserService }] });

class IUserRestService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IUserRestService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IUserRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IUserRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class UserRestService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = this.createRestClient();
    }
    getSearchKeyPackage() {
        throw new Error('Method not implemented.');
    }
    async get(userId) {
        const response = lastValueFrom(this.restClient.get(`user/${userId}`, { version: '2' }));
        return (await response).data;
    }
    update(user) {
        return lastValueFrom(this.restClient.put(`user/${user.id}`, user, { version: '2' }));
    }
    disable(user) {
        return lastValueFrom(this.restClient.put(`user/${user.id}/disable`, { version: '2' }));
    }
    enable(user) {
        return lastValueFrom(this.restClient.put(`user/${user.id}/enable`, { version: '2' }));
    }
    createRestClient() {
        if (!this.configProvider.config.userBaseURL) {
            throw new Error('Missing configuration, userBaseURL is undefined');
        }
        return new RestApiClient({
            baseUrl: this.configProvider.config.userBaseURL,
            token: this.configProvider.config.token$.pipe(filter(isNotNil)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserRestService, deps: [{ token: BaseUserConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseUserConfigProvider }] });

class AccountManageNotificationsComponent {
    constructor() {
        this.tokenStorage = inject(BaseLocalStorageService);
        this.userPreferencesService = inject(UserPreferencesService);
        this.notificationService = inject(E11NotificationsService);
        this.user = this.tokenStorage.getItem('user');
        this.loading = false;
        this.userEmailEnabled$ = this.getUserEmailEnabled();
    }
    getUserEmailEnabled() {
        return of(this.user).pipe(filter(isNotNil), mergeMap((user) => this.userPreferencesService.getUserPreferencesValueChanges(user.id)), map((userPreferences) => {
            if (userPreferences) {
                return userPreferences.emailEnabled;
            }
            return false;
        }));
    }
    async toggleNotificationEmail(value) {
        if (this.user) {
            this.loading = true;
            await this.userPreferencesService
                .setUserPreference('emailEnabled', !value, this.user)
                .catch((e) => this.errorNotification())
                .finally(() => {
                this.loading = false;
                this.userEmailEnabled$ = this.getUserEmailEnabled();
            });
        }
    }
    errorNotification() {
        const message = {
            title: 'Error changing preferences',
            message: 'There was an error changing your preferences. Please try again.',
            type: 'error',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationService.popNotificationMessage(message);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AccountManageNotificationsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: AccountManageNotificationsComponent, selector: "sdk-manage-notifications", ngImport: i0, template: "<h3 class=\"e11-text-skin-primary-accent e11-mb-4\">{{ \"Notification Preferences\" | translate }}</h3>\n<e11-panel [hasBorder]=\"true\" [hasShadow]=\"false\" [contentClassOverrides]=\"'e11-p-6'\">\n  <div *ngrxLet=\"userEmailEnabled$ as userEmailEnabled\" class=\"e11-w-full e11-flex e11-items-center\">\n    <!-- <e11-loader-dots *ngIf=\"loading\" [size]=\"'sm'\" [color]=\"'e11-bg-skin-primary-accent'\" [label]=\"''\"></e11-loader-dots> -->\n    <e11-switch\n      [size]=\"'md'\"\n      [spinnerLoading]=\"loading\"\n      [disabled]=\"loading\"\n      [checked]=\"userEmailEnabled\"\n      (changes)=\"toggleNotificationEmail(userEmailEnabled)\"\n    >\n    </e11-switch>\n\n    <div class=\"e11-flex e11-relative e11-w-full e11-h-16 e11-px-0 e11-overflow-hidden e11-items-center\">\n      <div\n        class=\"e11-flex e11-absolute e11-w-full e11-transition-all e11-duration-200 e11-ease-in-out e11-opacity-0\"\n        [ngClass]=\"{ 'e11-opacity-100': userEmailEnabled }\"\n      >\n        {{ \"Email notifications will be sent to the email associated with your account\" | translate }}\n      </div>\n      <div\n        class=\"e11-flex e11-absolute e11-w-full e11-transition-all e11-duration-200 e11-ease-in-out e11-opacity-0\"\n        [ngClass]=\"{ 'e11-opacity-100': !userEmailEnabled }\"\n      >\n        {{ \"Email notifications will NOT be sent to the email associated with your account\" | translate }}\n      </div>\n    </div>\n  </div>\n</e11-panel>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i3.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i4.E11SwitchComponent, selector: "e11-switch", inputs: ["id", "size", "color", "label", "containerClassOverrides", "containerClass", "disabled", "disabledText", "checked", "loading", "spinnerLoading"], outputs: ["changes", "onChange", "changeEvent", "OnchangeEvent"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AccountManageNotificationsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-manage-notifications', template: "<h3 class=\"e11-text-skin-primary-accent e11-mb-4\">{{ \"Notification Preferences\" | translate }}</h3>\n<e11-panel [hasBorder]=\"true\" [hasShadow]=\"false\" [contentClassOverrides]=\"'e11-p-6'\">\n  <div *ngrxLet=\"userEmailEnabled$ as userEmailEnabled\" class=\"e11-w-full e11-flex e11-items-center\">\n    <!-- <e11-loader-dots *ngIf=\"loading\" [size]=\"'sm'\" [color]=\"'e11-bg-skin-primary-accent'\" [label]=\"''\"></e11-loader-dots> -->\n    <e11-switch\n      [size]=\"'md'\"\n      [spinnerLoading]=\"loading\"\n      [disabled]=\"loading\"\n      [checked]=\"userEmailEnabled\"\n      (changes)=\"toggleNotificationEmail(userEmailEnabled)\"\n    >\n    </e11-switch>\n\n    <div class=\"e11-flex e11-relative e11-w-full e11-h-16 e11-px-0 e11-overflow-hidden e11-items-center\">\n      <div\n        class=\"e11-flex e11-absolute e11-w-full e11-transition-all e11-duration-200 e11-ease-in-out e11-opacity-0\"\n        [ngClass]=\"{ 'e11-opacity-100': userEmailEnabled }\"\n      >\n        {{ \"Email notifications will be sent to the email associated with your account\" | translate }}\n      </div>\n      <div\n        class=\"e11-flex e11-absolute e11-w-full e11-transition-all e11-duration-200 e11-ease-in-out e11-opacity-0\"\n        [ngClass]=\"{ 'e11-opacity-100': !userEmailEnabled }\"\n      >\n        {{ \"Email notifications will NOT be sent to the email associated with your account\" | translate }}\n      </div>\n    </div>\n  </div>\n</e11-panel>\n" }]
        }], ctorParameters: () => [] });

class FormCustomValidationService extends E11FormValidationService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class BusinessUserEditComponent {
    constructor(logger, formBuilder, customValidator, authUtilService, configProvider) {
        this.logger = logger;
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.authUtilService = authUtilService;
        this.configProvider = configProvider;
        this.disableUser = new EventEmitter();
        this.enableUser = new EventEmitter();
        this.submitEdit = new EventEmitter();
        this.cancelEdit = new EventEmitter();
        this.departmentOptions = [];
        this.allowRoles = true;
        this.allowEmail = true;
        this.allowDisable = true;
        this.userEmailInUse = false;
        this.disabledText = 'You must re-enable the user to edit their information';
        this.destroy$ = new Subject();
    }
    async ngOnInit() {
        this.loadSelectOptions();
        this.createForm();
        this.logger.log(this.user);
        // this.configProvider
        //   .getCurrentUserAppId()
        //   .pipe(filter(isNotNil), takeUntil(this.destroy$))
        //   .subscribe((id) => {
        //     this.loggedInUserId = id
        //   })
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    ngOnChanges(changes) {
        if (changes.user?.currentValue) {
            if (!this.loggedInUserId) {
                this.configProvider
                    .getCurrentUserAppId()
                    .pipe(filter(isNotNil), take(1))
                    .subscribe((id) => {
                    this.user = changes.user.currentValue;
                    this.handleChangeOptions(id);
                });
            }
        }
    }
    handleChangeOptions(loggedInUserId) {
        this.loggedInUserId = loggedInUserId;
        this.loadSelectOptions();
        if (this.loggedInUserId === this.user.id) {
            this.allowEmail = false;
            this.allowRoles = false;
            this.allowDisable = false;
        }
        else {
            this.allowEmail = true;
            this.allowRoles = true;
            this.allowDisable = true;
        }
        this.createForm();
    }
    get f() {
        return this.formEditUser.controls;
    }
    createForm() {
        this.formEditUser = this.formBuilder.group({
            firstName: new FormControl(this.user?.firstName, [
                Validators.required,
                this.customValidator.nameValidator(),
                this.customValidator.whitespaceValidator(),
            ]),
            lastName: new FormControl(this.user?.lastName, [
                Validators.required,
                this.customValidator.nameValidator(),
                this.customValidator.whitespaceValidator(),
            ]),
            email: new FormControl(this.user?.email, [Validators.required, this.customValidator.emailValidator()]),
            companyRole: new FormControl(this.user?.companyRole, []),
            department: new FormControl(this.user?.department, []),
            roles: new FormControl({ value: this.user?.roles, disabled: !this.allowRoles }, [Validators.required]),
        });
    }
    loadSelectOptions() {
        this.departmentOptions = [];
        if (this.departments) {
            this.departments.forEach((d) => {
                this.departmentOptions.push({ name: d, value: d });
            });
        }
    }
    async onSubmit() {
        if (this.formEditUser && this.formEditUser.valid && this.user) {
            const cleanEmailFromForm = this.formEditUser.value.email.trim().toLowerCase();
            const cleanEmailFromUser = this.user.email?.trim().toLowerCase();
            this.userEmailInUse = await this.checkEmail(cleanEmailFromForm, cleanEmailFromUser);
            if (this.userEmailInUse) {
                return;
            }
            const updatedUser = {
                id: this.user.id,
                customerKey: this.user.customerKey,
                isDisabled: this.user.isDisabled,
                firstName: this.formEditUser.value.firstName,
                lastName: this.formEditUser.value.lastName,
                email: cleanEmailFromForm,
                companyRole: this.formEditUser.value.companyRole,
                displayName: `${this.user.firstName} ${this.user.lastName}`,
                roles: this.formEditUser.value.roles,
                department: this.formEditUser.value.department,
            };
            this.logger.log('BusinessUserEditComponent.onSubmit -', { updatedUser });
            this.submitEdit.emit(updatedUser);
        }
    }
    async checkEmail(formEmail, userEmail) {
        let userEmailInUse = false;
        this.logger.log(`cleanEmailFromFrom: ${formEmail} cleanEmailFromUser: ${userEmail}`);
        if (formEmail !== userEmail) {
            const emailIsAvailable = await this.authUtilService.checkEmailAvailability(formEmail);
            userEmailInUse = !emailIsAvailable;
            this.logger.log(`The submitted email ${formEmail} in use: ${this.userEmailInUse}`);
        }
        return userEmailInUse;
    }
    enable() {
        this.enableUser.emit(this.user);
    }
    disable() {
        this.disableUser.emit(this.user);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserEditComponent, deps: [{ token: i1$2.E11Logger }, { token: i1$3.FormBuilder }, { token: FormCustomValidationService }, { token: i4$1.AuthUtilService }, { token: BaseUserConfigProvider }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: BusinessUserEditComponent, selector: "sdk-business-user-edit", inputs: { user: "user", availableRoles: "availableRoles", departments: "departments" }, outputs: { disableUser: "disableUser", enableUser: "enableUser", submitEdit: "submitEdit", cancelEdit: "cancelEdit" }, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"user\" class=\"e11-h-full e11-divide-y e11-divide-gray-200 e11-flex e11-flex-col e11-bg-white e11-shadow-xl\">\n  <div class=\"e11-flex-1 e11-h-0 e11-overflow-y-auto e11-overscroll-none\">\n    <div class=\"e11-py-6 e11-px-4 e11-bg-skin-primary sm:e11-px-6\">\n      <div class=\"e11-flex e11-items-center e11-justify-between e11-mb-2\">\n        <h3 class=\"e11-text-skin-white\" id=\"slide-over-title\">\n          {{ \"Edit User\" | translate }}\n        </h3>\n        <div class=\"e11-ml-3 e11-h-7 e11-flex e11-items-center\">\n          <button\n            (click)=\"cancelEdit.emit()\"\n            type=\"button\"\n            class=\"e11-flex e11-items-center e11-justify-center e11-bg-skin-primary e11-h-6 e11-w-6 e11-rounded-md e11-text-white/70 hover:e11-text-white focus:e11-outline-none focus:e11-ring-1 focus:e11-ring-white hover:e11-ring-1 hover:e11-ring-white\"\n          >\n            <span class=\"e11-sr-only\">Close panel</span>\n            <span class=\"material-icons-outlined md-18\"> close </span>\n          </button>\n        </div>\n      </div>\n      <div class=\"\">\n        <p class=\"e11-text-sm e11-text-white/70\">{{ user.firstName }} {{ user.lastName }}</p>\n      </div>\n    </div>\n\n    <form *ngIf=\"formEditUser\" class=\"e11-py-6 e11-px-4\" [formGroup]=\"formEditUser\" novalidate>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"firstName\"\n          id=\"firstName\"\n          label=\"{{ 'First Name' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"user.isDisabled\"\n          [disabledText]=\"disabledText | translate\"\n          formControlName=\"firstName\"\n          [required]=\"true\"\n          autocomplete=\"off\"\n          [hasError]=\"(f.firstName.errors && f.firstName.dirty) || f.firstName.invalid\"\n        >\n          <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.firstName\" label=\"{{ 'First Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"lastName\"\n          id=\"lastName\"\n          label=\"{{ 'Last Name' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"user.isDisabled\"\n          [disabledText]=\"disabledText | translate\"\n          formControlName=\"lastName\"\n          [required]=\"true\"\n          autocomplete=\"off\"\n          [hasError]=\"(f.lastName.errors && f.lastName.dirty) || f.lastName.invalid\"\n        >\n          <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.lastName\" label=\"{{ 'Last Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'email'\"\n          name=\"email\"\n          id=\"email_formLogin_body\"\n          label=\"{{ 'Email' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"!allowEmail || user.isDisabled\"\n          [disabledText]=\"disabledText | translate\"\n          [required]=\"true\"\n          formControlName=\"email\"\n          [hasError]=\"(f.email.errors && f.email.dirty) || f.email.invalid\"\n        >\n          <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n        </e11-input>\n        <div\n          class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n          *ngIf=\"userEmailInUse\"\n          [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n        >\n          <div class=\"e11-flex\">\n            <div class=\"e11-flex-shrink-0\">\n              <svg\n                class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 20 20\"\n                fill=\"currentColor\"\n                aria-hidden=\"true\"\n              >\n                <path\n                  fill-rule=\"evenodd\"\n                  d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n                  clip-rule=\"evenodd\"\n                />\n              </svg>\n            </div>\n            <div class=\"e11-ml-3\">\n              <div class=\"e11-text-sm\">\n                <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n              </div>\n              <div class=\"e11-mt-4\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-multi-select\n          id=\"rolesSelect\"\n          name=\"rolesSelect\"\n          [label]=\"'Roles' | translate\"\n          [options]=\"availableRoles!\"\n          selectMessage=\"Select Roles\"\n          [hasError]=\"false\"\n          [required]=\"true\"\n          [disabled]=\"!allowRoles || user.isDisabled\"\n          formControlName=\"roles\"\n        ></e11-multi-select>\n        <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.roles\" label=\"{{ 'Roles' | translate }}\"></e11-input-errors>\n      </div>\n\n      <div class=\"e11-w-full e11-mb-6\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"companyRole\"\n          id=\"companyRole\"\n          label=\"{{ 'Company Role' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"user.isDisabled\"\n          formControlName=\"companyRole\"\n          autocomplete=\"off\"\n          [hasError]=\"(f.companyRole.errors && f.companyRole.dirty) || f.companyRole.invalid\"\n        >\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-mb-6\">\n        <e11-select\n          name=\"departments\"\n          id=\"departments\"\n          [label]=\"'Department' | translate\"\n          [required]=\"false\"\n          [options]=\"departments | toSelectOptions\"\n          [disabled]=\"user.isDisabled\"\n          formControlName=\"department\"\n        >\n        </e11-select>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"e11-flex e11-w-full e11-p-4\">\n    <div class=\"e11-flex\">\n      <e11-button\n        *ngIf=\"!user.isDisabled\"\n        (click)=\"disable()\"\n        value=\"{{ 'Disable' | translate }}\"\n        [color]=\"'secondary'\"\n        [disabled]=\"!allowDisable || user.isDisabled\"\n      >\n      </e11-button>\n    </div>\n    <div class=\"e11-flex e11-grow e11-justify-end\">\n      <e11-button [ghost]=\"true\" [value]=\"'Cancel' | translate\" color=\"neutral\" (click)=\"cancelEdit.emit()\" [buttonGroup]=\"true\"> </e11-button>\n\n      <e11-button\n        *ngIf=\"!user.isDisabled\"\n        (click)=\"onSubmit()\"\n        value=\"{{ 'Save' | translate }}\"\n        [color]=\"'primary-accent'\"\n        [buttonGroup]=\"true\"\n        [disabled]=\"user.isDisabled\"\n      >\n      </e11-button>\n      <e11-button *ngIf=\"user.isDisabled\" (click)=\"enable()\" value=\"{{ 'Enable' | translate }}\" color=\"primary-accent\" [disabled]=\"!user.isDisabled\">\n      </e11-button>\n    </div>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "component", type: i6.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i8.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i9.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: i10.E11MultiSelectComponent, selector: "e11-multi-select", inputs: ["id", "name", "label", "selectMessage", "labelClassOverrides", "checkboxClassOverrides", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "searchable", "searchResultsEmpty", "isDropdownSelect", "dropdownContainerClass", "inputClassOverrides"], outputs: ["valueChange"] }, { kind: "component", type: i11.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }, { kind: "pipe", type: i9.E11SelectOptionsPipe, name: "toSelectOptions" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserEditComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-business-user-edit', template: "<div *ngIf=\"user\" class=\"e11-h-full e11-divide-y e11-divide-gray-200 e11-flex e11-flex-col e11-bg-white e11-shadow-xl\">\n  <div class=\"e11-flex-1 e11-h-0 e11-overflow-y-auto e11-overscroll-none\">\n    <div class=\"e11-py-6 e11-px-4 e11-bg-skin-primary sm:e11-px-6\">\n      <div class=\"e11-flex e11-items-center e11-justify-between e11-mb-2\">\n        <h3 class=\"e11-text-skin-white\" id=\"slide-over-title\">\n          {{ \"Edit User\" | translate }}\n        </h3>\n        <div class=\"e11-ml-3 e11-h-7 e11-flex e11-items-center\">\n          <button\n            (click)=\"cancelEdit.emit()\"\n            type=\"button\"\n            class=\"e11-flex e11-items-center e11-justify-center e11-bg-skin-primary e11-h-6 e11-w-6 e11-rounded-md e11-text-white/70 hover:e11-text-white focus:e11-outline-none focus:e11-ring-1 focus:e11-ring-white hover:e11-ring-1 hover:e11-ring-white\"\n          >\n            <span class=\"e11-sr-only\">Close panel</span>\n            <span class=\"material-icons-outlined md-18\"> close </span>\n          </button>\n        </div>\n      </div>\n      <div class=\"\">\n        <p class=\"e11-text-sm e11-text-white/70\">{{ user.firstName }} {{ user.lastName }}</p>\n      </div>\n    </div>\n\n    <form *ngIf=\"formEditUser\" class=\"e11-py-6 e11-px-4\" [formGroup]=\"formEditUser\" novalidate>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"firstName\"\n          id=\"firstName\"\n          label=\"{{ 'First Name' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"user.isDisabled\"\n          [disabledText]=\"disabledText | translate\"\n          formControlName=\"firstName\"\n          [required]=\"true\"\n          autocomplete=\"off\"\n          [hasError]=\"(f.firstName.errors && f.firstName.dirty) || f.firstName.invalid\"\n        >\n          <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.firstName\" label=\"{{ 'First Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"lastName\"\n          id=\"lastName\"\n          label=\"{{ 'Last Name' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"user.isDisabled\"\n          [disabledText]=\"disabledText | translate\"\n          formControlName=\"lastName\"\n          [required]=\"true\"\n          autocomplete=\"off\"\n          [hasError]=\"(f.lastName.errors && f.lastName.dirty) || f.lastName.invalid\"\n        >\n          <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.lastName\" label=\"{{ 'Last Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'email'\"\n          name=\"email\"\n          id=\"email_formLogin_body\"\n          label=\"{{ 'Email' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"!allowEmail || user.isDisabled\"\n          [disabledText]=\"disabledText | translate\"\n          [required]=\"true\"\n          formControlName=\"email\"\n          [hasError]=\"(f.email.errors && f.email.dirty) || f.email.invalid\"\n        >\n          <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n        </e11-input>\n        <div\n          class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n          *ngIf=\"userEmailInUse\"\n          [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n        >\n          <div class=\"e11-flex\">\n            <div class=\"e11-flex-shrink-0\">\n              <svg\n                class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 20 20\"\n                fill=\"currentColor\"\n                aria-hidden=\"true\"\n              >\n                <path\n                  fill-rule=\"evenodd\"\n                  d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n                  clip-rule=\"evenodd\"\n                />\n              </svg>\n            </div>\n            <div class=\"e11-ml-3\">\n              <div class=\"e11-text-sm\">\n                <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n              </div>\n              <div class=\"e11-mt-4\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-multi-select\n          id=\"rolesSelect\"\n          name=\"rolesSelect\"\n          [label]=\"'Roles' | translate\"\n          [options]=\"availableRoles!\"\n          selectMessage=\"Select Roles\"\n          [hasError]=\"false\"\n          [required]=\"true\"\n          [disabled]=\"!allowRoles || user.isDisabled\"\n          formControlName=\"roles\"\n        ></e11-multi-select>\n        <e11-input-errors [parentForm]=\"formEditUser\" [formControl]=\"f.roles\" label=\"{{ 'Roles' | translate }}\"></e11-input-errors>\n      </div>\n\n      <div class=\"e11-w-full e11-mb-6\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"companyRole\"\n          id=\"companyRole\"\n          label=\"{{ 'Company Role' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formEditUser\"\n          [autofocus]=\"false\"\n          [disabled]=\"user.isDisabled\"\n          formControlName=\"companyRole\"\n          autocomplete=\"off\"\n          [hasError]=\"(f.companyRole.errors && f.companyRole.dirty) || f.companyRole.invalid\"\n        >\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-mb-6\">\n        <e11-select\n          name=\"departments\"\n          id=\"departments\"\n          [label]=\"'Department' | translate\"\n          [required]=\"false\"\n          [options]=\"departments | toSelectOptions\"\n          [disabled]=\"user.isDisabled\"\n          formControlName=\"department\"\n        >\n        </e11-select>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"e11-flex e11-w-full e11-p-4\">\n    <div class=\"e11-flex\">\n      <e11-button\n        *ngIf=\"!user.isDisabled\"\n        (click)=\"disable()\"\n        value=\"{{ 'Disable' | translate }}\"\n        [color]=\"'secondary'\"\n        [disabled]=\"!allowDisable || user.isDisabled\"\n      >\n      </e11-button>\n    </div>\n    <div class=\"e11-flex e11-grow e11-justify-end\">\n      <e11-button [ghost]=\"true\" [value]=\"'Cancel' | translate\" color=\"neutral\" (click)=\"cancelEdit.emit()\" [buttonGroup]=\"true\"> </e11-button>\n\n      <e11-button\n        *ngIf=\"!user.isDisabled\"\n        (click)=\"onSubmit()\"\n        value=\"{{ 'Save' | translate }}\"\n        [color]=\"'primary-accent'\"\n        [buttonGroup]=\"true\"\n        [disabled]=\"user.isDisabled\"\n      >\n      </e11-button>\n      <e11-button *ngIf=\"user.isDisabled\" (click)=\"enable()\" value=\"{{ 'Enable' | translate }}\" color=\"primary-accent\" [disabled]=\"!user.isDisabled\">\n      </e11-button>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$2.E11Logger }, { type: i1$3.FormBuilder }, { type: FormCustomValidationService }, { type: i4$1.AuthUtilService }, { type: BaseUserConfigProvider }], propDecorators: { user: [{
                type: Input
            }], availableRoles: [{
                type: Input
            }], departments: [{
                type: Input
            }], disableUser: [{
                type: Output
            }], enableUser: [{
                type: Output
            }], submitEdit: [{
                type: Output
            }], cancelEdit: [{
                type: Output
            }] } });

const connectRefresh = (renderFn, unmountFn) => (widgetParams) => ({
    $$type: 'custom.refresh',
    init: function ({ instantSearchInstance }) {
        renderFn({
            refresh() { },
            widgetParams,
            instantSearchInstance,
        }, true);
    },
    render({ instantSearchInstance }) {
        const refresh = instantSearchInstance.refresh.bind(instantSearchInstance);
        renderFn({ refresh, widgetParams, instantSearchInstance }, false);
    },
    dispose() {
        if (unmountFn) {
            unmountFn();
        }
    },
});
class RefreshComponent extends TypedBaseWidget {
    // Rendering options
    constructor(parentIndex, instantSearchInstance) {
        super('Refresh');
        this.parentIndex = parentIndex;
        this.instantSearchInstance = instantSearchInstance;
        this.state = {
            refresh() { },
        };
    }
    ngOnInit() {
        this.createWidget(connectRefresh, {
        // instance options
        });
        super.ngOnInit();
    }
    refresh() {
        this.state.refresh();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RefreshComponent, deps: [{ token: forwardRef(() => NgAisIndex), optional: true }, { token: forwardRef(() => NgAisInstantSearch) }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: RefreshComponent, selector: "search-refresh", usesInheritance: true, ngImport: i0, template: `<!--<button (click)="state.refresh()">Refresh</button>--> `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RefreshComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'search-refresh',
                    template: `<!--<button (click)="state.refresh()">Refresh</button>--> `,
                }]
        }], ctorParameters: () => [{ type: i4$2.NgAisIndex, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => NgAisIndex)]
                }, {
                    type: Optional
                }] }, { type: i4$2.NgAisInstantSearch, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => NgAisInstantSearch)]
                }] }] });

class RolesDisplayPipe {
    constructor(roleDisplayService) {
        this.roleDisplayService = roleDisplayService;
        this.roleDisplayConfig = this.roleDisplayService.roleDisplayConfig;
    }
    transform(roles) {
        if (!roles)
            return roles;
        if (!this.roleDisplayConfig)
            return roles.join(', ');
        const { allRoles, roleLabelMap } = this.roleDisplayConfig;
        return roles.map((role) => roleLabelMap[role] ?? role).join(', '); // TODO: consider .filter((role) => allRoles.includes(role))
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RolesDisplayPipe, deps: [{ token: i1$4.RoleDisplayService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: RolesDisplayPipe, name: "rolesDisplay" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RolesDisplayPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'rolesDisplay' }]
        }], ctorParameters: () => [{ type: i1$4.RoleDisplayService }] });

class UserEntryComponent {
    constructor() {
        this.index = 0;
        this.selectedUser = new EventEmitter();
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserEntryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UserEntryComponent, selector: "ui-user-entry", inputs: { user: "user", index: "index" }, outputs: { selectedUser: "selectedUser" }, ngImport: i0, template: `
    <div
      (click)="selectedUser.emit(user)"
      [ngClass]="{ 'e11-bg-skin-white': index % 2 === 0 }"
      class="e11-flex e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-h-12 e11-cursor-pointer hover:e11-text-skin-primary hover:e11-bg-skin-primary-accent/10 md:e11-px-4"
    >
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-1/4 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'First Name' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2">{{ user?.firstName }}</p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-1/4 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Last Name' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2">{{ user?.lastName }}</p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-6/12 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Email' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2">{{ user?.email }}</p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-4/12 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Roles' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2" [attr.title]="user?.roles | rolesDisplay">
          {{ user?.roles | rolesDisplay }}
        </p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12 md:e11-text-center ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Disabled' | translate
        }}</span>
        <p class="e11-skeleton-empty e11-mb-0" *ngIf="!user"></p>
        <span class="e11-text-skin-primary" *ngIf="user && user?.disabled"> {{ user?.disabled | date: 'MMM yyyy' }} </span>
        <span class="e11-text-skin-light" *ngIf="user && !user?.disabled"> - </span>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }, { kind: "pipe", type: RolesDisplayPipe, name: "rolesDisplay" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserEntryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ui-user-entry',
                    template: `
    <div
      (click)="selectedUser.emit(user)"
      [ngClass]="{ 'e11-bg-skin-white': index % 2 === 0 }"
      class="e11-flex e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-h-12 e11-cursor-pointer hover:e11-text-skin-primary hover:e11-bg-skin-primary-accent/10 md:e11-px-4"
    >
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-1/4 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'First Name' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2">{{ user?.firstName }}</p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-1/4 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Last Name' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2">{{ user?.lastName }}</p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-6/12 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Email' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2">{{ user?.email }}</p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-4/12 ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Roles' | translate
        }}</span>
        <p class="e11-truncate e11-mb-0 e11-break-all e11-skeleton-empty e11-pr-2" [attr.title]="user?.roles | rolesDisplay">
          {{ user?.roles | rolesDisplay }}
        </p>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12 md:e11-text-center ellipsis">
        <span class="md:e11-hidden e11-min-w-[100px] e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100">{{
          'Disabled' | translate
        }}</span>
        <p class="e11-skeleton-empty e11-mb-0" *ngIf="!user"></p>
        <span class="e11-text-skin-primary" *ngIf="user && user?.disabled"> {{ user?.disabled | date: 'MMM yyyy' }} </span>
        <span class="e11-text-skin-light" *ngIf="user && !user?.disabled"> - </span>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { user: [{
                type: Input
            }], index: [{
                type: Input
            }], selectedUser: [{
                type: Output
            }] } });

class UserListComponent {
    constructor() {
        this.loading = false;
        this.selectedUser = new EventEmitter();
    }
    ngOnInit() { }
    handleSelectedUser(user) {
        this.selectedUser.emit(user);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UserListComponent, selector: "ui-user-list", inputs: { users: "users", loading: "loading" }, outputs: { selectedUser: "selectedUser" }, ngImport: i0, template: `
    <ui-user-entry (selectedUser)="handleSelectedUser($event)" *ngFor="let user of users; let i = index" [user]="user" [index]="i"></ui-user-entry>
    <ng-container *ngIf="loading">
      <ui-user-entry *ngFor="let i of 4 | range" [index]="i"></ui-user-entry>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: UserEntryComponent, selector: "ui-user-entry", inputs: ["user", "index"], outputs: ["selectedUser"] }, { kind: "pipe", type: i3$1.RangePipe, name: "range" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ui-user-list',
                    template: `
    <ui-user-entry (selectedUser)="handleSelectedUser($event)" *ngFor="let user of users; let i = index" [user]="user" [index]="i"></ui-user-entry>
    <ng-container *ngIf="loading">
      <ui-user-entry *ngFor="let i of 4 | range" [index]="i"></ui-user-entry>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { users: [{
                type: Input
            }], loading: [{
                type: Input
            }], selectedUser: [{
                type: Output
            }] } });

class UserSearchComponent {
    constructor(logger) {
        this.logger = logger;
        this.selectedUserId = new EventEmitter();
        this.selectedUser = new EventEmitter();
    }
    ngOnInit() {
        if (!this.searchAppId || !this.searchKey || !this.searchParams) {
            throw new Error('searchAppId, searchKey, and searchParams are required');
        }
        this.config = {
            indexName: SEARCH_INDICES.USER,
            searchClient: algoliasearch(this.searchAppId, this.searchKey),
        };
    }
    refresh() {
        this.searchRefresh.refresh();
    }
    selectUser(user) {
        this.logger.log(user);
        this.selectedUserId.emit(user.id);
        this.selectedUser.emit(user);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserSearchComponent, deps: [{ token: i1$2.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UserSearchComponent, selector: "sdk-user-search", inputs: { searchKey: "searchKey", searchAppId: "searchAppId", searchFilters: "searchFilters", searchParams: "searchParams" }, outputs: { selectedUserId: "selectedUserId", selectedUser: "selectedUser" }, viewQueries: [{ propertyName: "searchRefresh", first: true, predicate: ["searchRefresh"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"config && searchParams\">\n  <ais-instantsearch #instantSearch [config]=\"config\">\n    <ais-configure [searchParameters]=\"searchParams\"></ais-configure>\n    <search-refresh #searchRefresh></search-refresh>\n    <div class=\"e11-flex e11-w-full e11-items-center e11-mb-4\">\n      <div class=\"e11-w-full md:e11-w-1/4\">\n        <ais-search-box\n          class=\"e11-w-full e11-pb-6\"\n          placeholder=\"{{ 'Search' | translate }}\"\n          submitTitle=\"string\"\n          resetTitle=\"string\"\n          [searchAsYouType]=\"true\"\n          [autofocus]=\"true\"\n        ></ais-search-box>\n      </div>\n    </div>\n\n    <div class=\"e11-hidden md:e11-flex e11-py-4 md:e11-px-4 e11-text-sm e11-font-primary-demibold e11-border-b e11-border-skin-grey/50\">\n      <div class=\"e11-w-1/4\">{{ \"First Name\" | translate }}</div>\n      <div class=\"e11-w-1/4\">{{ \"Last Name\" | translate }}</div>\n      <div class=\"e11-w-6/12\">{{ \"Email\" | translate }}</div>\n      <div class=\"e11-w-4/12\">{{ \"Roles\" | translate }}</div>\n      <div class=\"e11-w-2/12 text-center ellipsis\">{{ \"Disabled\" | translate }}</div>\n    </div>\n\n    <ais-hits>\n      <ng-template let-hits=\"hits\" let-results=\"results\">\n        <div class=\"e11-w-full\" *ngIf=\"!results\">\n          <ui-user-list [loading]=\"true\"></ui-user-list>\n        </div>\n        <!-- Empty State -->\n        <div class=\"e11-mb-16\" *ngIf=\"results && hits.length === 0\">\n          <!-- Empty State / No Users -->\n          <e11-empty-state\n            [icon]=\"'description'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No Users' | translate }}\"\n            subtitle=\"{{ 'There are currently no users meeting your search criteria.' | translate }}\"\n            [clickable]=\"false\"\n          ></e11-empty-state>\n        </div>\n        <!-- List -->\n        <div class=\"e11-flex e11-w-full\" *ngIf=\"hits.length > 0\">\n          <div class=\"e11-w-full e11-overflow-hidden\">\n            <div>\n              <ui-user-list (selectedUser)=\"selectUser($event)\" [users]=\"hits\"></ui-user-list>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </ais-hits>\n    <ais-stats>\n      <ng-template let-state=\"state\">\n        <div class=\"e11-w-full e11-mt-8\" *ngIf=\"state.nbHits > searchParams.hitsPerPage\">\n          <ais-pagination></ais-pagination>\n        </div>\n      </ng-template>\n    </ais-stats>\n  </ais-instantsearch>\n</div>\n", styles: [":host ::ng-deep .ais-Pagination{text-align:center;justify-content:center;display:flex}:host ::ng-deep .ais-Pagination-item{display:inline-block}:host ::ng-deep .ais-Pagination-item a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}:host ::ng-deep .ais-SearchBox-form{display:block}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit{display:none;height:30px;line-height:normal;padding:5px 10px;border-radius:2px;border-left:none}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit .ais-SearchBox-submitIcon{height:15px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-input{display:block;width:100%;padding:10px;margin-right:1rem;border-radius:2px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-reset{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$2.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i4$2.NgAisInstantSearch, selector: "ais-instantsearch", inputs: ["config", "instanceName"], outputs: ["change"] }, { kind: "component", type: i4$2.NgAisHits, selector: "ais-hits", inputs: ["escapeHTML", "transformItems"] }, { kind: "component", type: i4$2.NgAisSearchBox, selector: "ais-search-box", inputs: ["placeholder", "submitTitle", "resetTitle", "searchAsYouType", "autofocus", "showLoadingIndicator"], outputs: ["submit", "reset", "change", "focus", "blur"] }, { kind: "component", type: i4$2.NgAisPagination, selector: "ais-pagination", inputs: ["showFirst", "showLast", "showPrevious", "showNext", "padding", "totalPages"] }, { kind: "component", type: i4$2.NgAisStats, selector: "ais-stats" }, { kind: "component", type: i4$2.NgAisConfigure, selector: "ais-configure", inputs: ["searchParameters"] }, { kind: "component", type: RefreshComponent, selector: "search-refresh" }, { kind: "component", type: UserListComponent, selector: "ui-user-list", inputs: ["users", "loading"], outputs: ["selectedUser"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-user-search', template: "<div *ngIf=\"config && searchParams\">\n  <ais-instantsearch #instantSearch [config]=\"config\">\n    <ais-configure [searchParameters]=\"searchParams\"></ais-configure>\n    <search-refresh #searchRefresh></search-refresh>\n    <div class=\"e11-flex e11-w-full e11-items-center e11-mb-4\">\n      <div class=\"e11-w-full md:e11-w-1/4\">\n        <ais-search-box\n          class=\"e11-w-full e11-pb-6\"\n          placeholder=\"{{ 'Search' | translate }}\"\n          submitTitle=\"string\"\n          resetTitle=\"string\"\n          [searchAsYouType]=\"true\"\n          [autofocus]=\"true\"\n        ></ais-search-box>\n      </div>\n    </div>\n\n    <div class=\"e11-hidden md:e11-flex e11-py-4 md:e11-px-4 e11-text-sm e11-font-primary-demibold e11-border-b e11-border-skin-grey/50\">\n      <div class=\"e11-w-1/4\">{{ \"First Name\" | translate }}</div>\n      <div class=\"e11-w-1/4\">{{ \"Last Name\" | translate }}</div>\n      <div class=\"e11-w-6/12\">{{ \"Email\" | translate }}</div>\n      <div class=\"e11-w-4/12\">{{ \"Roles\" | translate }}</div>\n      <div class=\"e11-w-2/12 text-center ellipsis\">{{ \"Disabled\" | translate }}</div>\n    </div>\n\n    <ais-hits>\n      <ng-template let-hits=\"hits\" let-results=\"results\">\n        <div class=\"e11-w-full\" *ngIf=\"!results\">\n          <ui-user-list [loading]=\"true\"></ui-user-list>\n        </div>\n        <!-- Empty State -->\n        <div class=\"e11-mb-16\" *ngIf=\"results && hits.length === 0\">\n          <!-- Empty State / No Users -->\n          <e11-empty-state\n            [icon]=\"'description'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No Users' | translate }}\"\n            subtitle=\"{{ 'There are currently no users meeting your search criteria.' | translate }}\"\n            [clickable]=\"false\"\n          ></e11-empty-state>\n        </div>\n        <!-- List -->\n        <div class=\"e11-flex e11-w-full\" *ngIf=\"hits.length > 0\">\n          <div class=\"e11-w-full e11-overflow-hidden\">\n            <div>\n              <ui-user-list (selectedUser)=\"selectUser($event)\" [users]=\"hits\"></ui-user-list>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </ais-hits>\n    <ais-stats>\n      <ng-template let-state=\"state\">\n        <div class=\"e11-w-full e11-mt-8\" *ngIf=\"state.nbHits > searchParams.hitsPerPage\">\n          <ais-pagination></ais-pagination>\n        </div>\n      </ng-template>\n    </ais-stats>\n  </ais-instantsearch>\n</div>\n", styles: [":host ::ng-deep .ais-Pagination{text-align:center;justify-content:center;display:flex}:host ::ng-deep .ais-Pagination-item{display:inline-block}:host ::ng-deep .ais-Pagination-item a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}:host ::ng-deep .ais-SearchBox-form{display:block}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit{display:none;height:30px;line-height:normal;padding:5px 10px;border-radius:2px;border-left:none}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit .ais-SearchBox-submitIcon{height:15px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-input{display:block;width:100%;padding:10px;margin-right:1rem;border-radius:2px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-reset{display:none}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.E11Logger }], propDecorators: { searchKey: [{
                type: Input
            }], searchAppId: [{
                type: Input
            }], searchFilters: [{
                type: Input
            }], searchParams: [{
                type: Input
            }], selectedUserId: [{
                type: Output
            }], selectedUser: [{
                type: Output
            }], searchRefresh: [{
                type: ViewChild,
                args: ['searchRefresh']
            }] } });

var USER_FILTERS;
(function (USER_FILTERS) {
    USER_FILTERS["ACTIVE"] = "isDisabled: false";
    USER_FILTERS["DISABLED"] = "isDisabled: true";
})(USER_FILTERS || (USER_FILTERS = {}));
const WAIT_FOR_ALGOLIA_MS = 3000; // seems to be the magic number to wait for Algolia to update
class ManageBusinessUsersComponent {
    constructor(sideOverService, logger, userRestService, notificationsService) {
        this.sideOverService = sideOverService;
        this.logger = logger;
        this.userRestService = userRestService;
        this.notificationsService = notificationsService;
        this.onUserDisabled = new EventEmitter();
        this.onUserEnabled = new EventEmitter();
        this.loadingForm = new FormGroup({ loading: new FormControl() });
        this.loading = false;
    }
    async ngOnInit() {
        let filters = this.userFilters;
        if (this.customerKey) {
            filters += ` AND customerKey: ${this.customerKey}`;
        }
        this.searchParams = { hitsPerPage: 15, filters: filters };
        this.logger.log(this.searchParams);
        this.loading = true;
        let keyPackage = this.searchKeyPackage;
        if (!keyPackage) {
            this.logger.log('No key package specified, using default.');
            keyPackage = await this.userRestService.getSearchKeyPackage().toPromise();
        }
        this.searchAppId = keyPackage.searchAppId;
        this.searchKey = keyPackage.searchKey;
        this.loading = false;
    }
    async editUser(userId) {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.selectedUser = await this.userRestService.get(userId);
        this.loading = false;
        this.logger.log(this.selectedUser);
        this.sideOverService.overlayToggle(true, this.editUserSideOver);
    }
    async onSubmit(user, emailEditConfirmed = false) {
        this.editedUserData = user;
        this.logger.log(user);
        this.sideOverService.overlayToggle(false);
        if (user.email !== this.selectedUser?.email && !emailEditConfirmed) {
            this.editEmailConfirmation.open();
            return;
        }
        if (user) {
            this.loading = true;
            this.selectedUser = user;
            await this.userRestService.update(user);
            await this.sleep(WAIT_FOR_ALGOLIA_MS);
            this.search.refresh();
            this.loading = false;
            const message = {
                title: 'Changes Saved',
                message: `${user.firstName} ${user.lastName} has been updated.`,
                type: 'success',
                autoClose: true,
                dismissOnRouteChange: true,
            };
            this.notificationsService.popNotificationMessage(message);
        }
    }
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    async disableUser(user) {
        this.logger.log(user);
        this.sideOverService.overlayToggle(false);
        this.loading = true;
        await this.userRestService.disable(user);
        await this.sleep(WAIT_FOR_ALGOLIA_MS);
        this.search.refresh();
        this.loading = false;
        const message = {
            title: 'Changes Saved',
            message: `${user.firstName} ${user.lastName} has been disabled.`,
            type: 'success',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationsService.popNotificationMessage(message);
        this.onUserDisabled.emit();
    }
    async enableUser(user) {
        this.logger.log(user);
        this.sideOverService.overlayToggle(false);
        this.loading = true;
        await this.userRestService.enable(user);
        await this.sleep(WAIT_FOR_ALGOLIA_MS);
        this.search.refresh();
        this.loading = false;
        const message = {
            title: 'Changes Saved',
            message: `${user.firstName} ${user.lastName} has been enabled.`,
            type: 'success',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationsService.popNotificationMessage(message);
        this.onUserEnabled.emit();
    }
    onClose() {
        this.sideOverService.overlayToggle(false);
    }
    confirmEmailEdit(value) {
        if (!value) {
            return;
        }
        if (this.editedUserData) {
            this.onSubmit(this.editedUserData, value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManageBusinessUsersComponent, deps: [{ token: i1$5.E11SideOverService }, { token: i1$2.E11Logger }, { token: IUserRestService }, { token: i2.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ManageBusinessUsersComponent, selector: "sdk-manage-business-users", inputs: { userFilters: "userFilters", availableRoles: "availableRoles", departments: "departments", searchKeyPackage: "searchKeyPackage", customerKey: "customerKey" }, outputs: { onUserDisabled: "onUserDisabled", onUserEnabled: "onUserEnabled" }, viewQueries: [{ propertyName: "editUserSideOver", first: true, predicate: ["editUserSideOver"], descendants: true }, { propertyName: "search", first: true, predicate: ["search"], descendants: true }, { propertyName: "editEmailConfirmation", first: true, predicate: ["editEmailConfirmation"], descendants: true }], ngImport: i0, template: "<div class=\"parent-container e11-relative\">\n  <div *ngIf=\"searchKey && searchAppId; else loading\">\n    <sdk-user-search\n      #search\n      *ngIf=\"searchKey && searchAppId && searchParams\"\n      [searchKey]=\"searchKey\"\n      [searchAppId]=\"searchAppId\"\n      [searchParams]=\"searchParams\"\n      (selectedUserId)=\"editUser($event)\"\n    ></sdk-user-search>\n  </div>\n</div>\n\n<ng-template #editUserSideOver>\n  <div class=\"e11-h-full e11-bg-white\">\n    <sdk-business-user-edit\n      [user]=\"selectedUser\"\n      [departments]=\"departments\"\n      [availableRoles]=\"availableRoles\"\n      (submitEdit)=\"onSubmit($event)\"\n      (disableUser)=\"disableUser($event)\"\n      (enableUser)=\"enableUser($event)\"\n      (cancelEdit)=\"onClose()\"\n    ></sdk-business-user-edit>\n  </div>\n</ng-template>\n\n<e11-confirmation\n  #editEmailConfirmation\n  confirmTitle=\"{{ 'Update this user email' | translate }}\"\n  confirmText=\"{{ 'Confirm' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  (answer)=\"confirmEmailEdit($event)\"\n>\n  <p>{{ \"You have updated the email address for this user, which will also update their login credentials.\" | translate }}</p>\n  <p>{{ \"Please confirm or cancel this action.\" | translate }}</p>\n</e11-confirmation>\n\n<ng-template #loading>\n  <div class=\"e11-w-1/4 e11-mb-4\">\n    <form [formGroup]=\"loadingForm\">\n      <e11-input\n        [loading]=\"true\"\n        [parentForm]=\"loadingForm\"\n        [formControlName]=\"'loading'\"\n        [type]=\"'text'\"\n        placeholder=\"{{ 'Search' | translate }}\"\n        [disabled]=\"true\"\n      ></e11-input>\n    </form>\n  </div>\n  <div class=\"e11-hidden md:e11-flex e11-py-4 md:e11-px-4 e11-text-sm e11-font-primary-demibold e11-border-b e11-border-skin-grey/50\">\n    <div class=\"e11-w-1/4\">{{ \"First Name\" | translate }}</div>\n    <div class=\"e11-w-1/4\">{{ \"Last Name\" | translate }}</div>\n    <div class=\"e11-w-6/12\">{{ \"Email\" | translate }}</div>\n    <div class=\"e11-w-4/12\">{{ \"Roles\" | translate }}</div>\n    <div class=\"e11-w-2/12 text-center ellipsis\">{{ \"Disabled\" | translate }}</div>\n  </div>\n  <ui-user-list [loading]=\"true\"></ui-user-list>\n</ng-template>\n", styles: [".e11-loader-fading{position:absolute;opacity:0;z-index:-2;top:13rem;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 1.2s}.e11-loader-fading.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}\n"], dependencies: [{ kind: "component", type: i5.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i8.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: UserSearchComponent, selector: "sdk-user-search", inputs: ["searchKey", "searchAppId", "searchFilters", "searchParams"], outputs: ["selectedUserId", "selectedUser"] }, { kind: "component", type: BusinessUserEditComponent, selector: "sdk-business-user-edit", inputs: ["user", "availableRoles", "departments"], outputs: ["disableUser", "enableUser", "submitEdit", "cancelEdit"] }, { kind: "component", type: UserListComponent, selector: "ui-user-list", inputs: ["users", "loading"], outputs: ["selectedUser"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManageBusinessUsersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-manage-business-users', template: "<div class=\"parent-container e11-relative\">\n  <div *ngIf=\"searchKey && searchAppId; else loading\">\n    <sdk-user-search\n      #search\n      *ngIf=\"searchKey && searchAppId && searchParams\"\n      [searchKey]=\"searchKey\"\n      [searchAppId]=\"searchAppId\"\n      [searchParams]=\"searchParams\"\n      (selectedUserId)=\"editUser($event)\"\n    ></sdk-user-search>\n  </div>\n</div>\n\n<ng-template #editUserSideOver>\n  <div class=\"e11-h-full e11-bg-white\">\n    <sdk-business-user-edit\n      [user]=\"selectedUser\"\n      [departments]=\"departments\"\n      [availableRoles]=\"availableRoles\"\n      (submitEdit)=\"onSubmit($event)\"\n      (disableUser)=\"disableUser($event)\"\n      (enableUser)=\"enableUser($event)\"\n      (cancelEdit)=\"onClose()\"\n    ></sdk-business-user-edit>\n  </div>\n</ng-template>\n\n<e11-confirmation\n  #editEmailConfirmation\n  confirmTitle=\"{{ 'Update this user email' | translate }}\"\n  confirmText=\"{{ 'Confirm' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  (answer)=\"confirmEmailEdit($event)\"\n>\n  <p>{{ \"You have updated the email address for this user, which will also update their login credentials.\" | translate }}</p>\n  <p>{{ \"Please confirm or cancel this action.\" | translate }}</p>\n</e11-confirmation>\n\n<ng-template #loading>\n  <div class=\"e11-w-1/4 e11-mb-4\">\n    <form [formGroup]=\"loadingForm\">\n      <e11-input\n        [loading]=\"true\"\n        [parentForm]=\"loadingForm\"\n        [formControlName]=\"'loading'\"\n        [type]=\"'text'\"\n        placeholder=\"{{ 'Search' | translate }}\"\n        [disabled]=\"true\"\n      ></e11-input>\n    </form>\n  </div>\n  <div class=\"e11-hidden md:e11-flex e11-py-4 md:e11-px-4 e11-text-sm e11-font-primary-demibold e11-border-b e11-border-skin-grey/50\">\n    <div class=\"e11-w-1/4\">{{ \"First Name\" | translate }}</div>\n    <div class=\"e11-w-1/4\">{{ \"Last Name\" | translate }}</div>\n    <div class=\"e11-w-6/12\">{{ \"Email\" | translate }}</div>\n    <div class=\"e11-w-4/12\">{{ \"Roles\" | translate }}</div>\n    <div class=\"e11-w-2/12 text-center ellipsis\">{{ \"Disabled\" | translate }}</div>\n  </div>\n  <ui-user-list [loading]=\"true\"></ui-user-list>\n</ng-template>\n", styles: [".e11-loader-fading{position:absolute;opacity:0;z-index:-2;top:13rem;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 1.2s}.e11-loader-fading.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}\n"] }]
        }], ctorParameters: () => [{ type: i1$5.E11SideOverService }, { type: i1$2.E11Logger }, { type: IUserRestService }, { type: i2.E11NotificationsService }], propDecorators: { userFilters: [{
                type: Input
            }], availableRoles: [{
                type: Input
            }], departments: [{
                type: Input
            }], searchKeyPackage: [{
                type: Input
            }], customerKey: [{
                type: Input
            }], editUserSideOver: [{
                type: ViewChild,
                args: ['editUserSideOver']
            }], search: [{
                type: ViewChild,
                args: ['search']
            }], editEmailConfirmation: [{
                type: ViewChild,
                args: ['editEmailConfirmation']
            }], onUserDisabled: [{
                type: Output
            }], onUserEnabled: [{
                type: Output
            }] } });

class IUserService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IUserService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ITermsService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ITermsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ITermsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ITermsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ManagePersonalAccountComponent {
    set _formBuilder(formBuilder) {
        this.formBuilderComponent = formBuilder;
        if (formBuilder)
            this.addressFormService.init(formBuilder);
    }
    constructor(tokenStorage, notificationsService, userService, customValidator, addressFormService, logger) {
        this.tokenStorage = tokenStorage;
        this.notificationsService = notificationsService;
        this.userService = userService;
        this.customValidator = customValidator;
        this.addressFormService = addressFormService;
        this.logger = logger;
        this.includeDisplayName = true; // On by default - value falls back to firstName + lastName when turned off
        this.user = this.tokenStorage.getItem('user');
    }
    ngOnInit() {
        this.fieldGroup = this.initFormAccount();
    }
    async onSubmitFormAccount() {
        this.formBuilderComponent.onSubmitClick();
        const form = this.formBuilderComponent.form;
        if (form.valid) {
            const user = this.tokenStorage.getItem('user');
            const { firstName, lastName } = form.value;
            const updatedUser = {
                ...user,
                ...form.value,
                displayName: this.includeDisplayName ? form.value.displayName : `${firstName} ${lastName}`,
            };
            await this.userService.update(updatedUser);
            this.tokenStorage.setItem('user', JSON.stringify(updatedUser));
            this.successNotification();
        }
        else {
            this.logger.log('invalid form: ', form);
            this.errorNotification();
        }
    }
    ngOnDestroy() {
        this.addressFormService.ngOnDestroy();
    }
    successNotification() {
        const message = {
            title: 'Good work!',
            message: 'Your information has been saved.',
            type: 'success',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationsService.popNotificationMessage(message);
    }
    errorNotification() {
        const message = {
            title: 'Please review',
            message: "Something doesn't look right",
            type: 'warning',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationsService.popNotificationMessage(message);
    }
    initFormAccount() {
        const displayNameValidators = this.includeDisplayName
            ? [
                Validators.required,
                Validators.maxLength(24),
                Validators.minLength(2),
                this.customValidator.isAlphaNumericValidator(),
                this.customValidator.minLengthAlphanumeric(1),
            ]
            : [];
        return e11FormFor()([
            e11LayoutGroup([
                e11FormLayoutInlineGrid([
                    e11FieldInputText('firstName', 'First Name', undefined, {
                        validatorOrOpts: [
                            Validators.required,
                            this.customValidator.nameValidator(),
                            this.customValidator.minLengthAlphanumeric(1),
                            Validators.maxLength(20),
                        ],
                    }),
                    e11FieldInputText('lastName', 'Last Name', undefined, {
                        validatorOrOpts: [
                            Validators.required,
                            this.customValidator.nameValidator(),
                            this.customValidator.minLengthAlphanumeric(1),
                            Validators.maxLength(20),
                        ],
                    }),
                ]),
                e11FormLayoutInlineGrid([
                    e11FieldInputText('pronouns', 'Pronouns', undefined, {
                        validatorOrOpts: [this.customValidator.minLengthAlphanumeric(1), Validators.maxLength(30)],
                    }),
                    e11FieldInputPhone('phoneNumber', 'Phone', undefined, { validatorOrOpts: [Validators.minLength(ERROR_HANDLING.PHONE_MIN_LENGTH)] }),
                ]),
                e11FormLayoutInlineGrid([
                    e11FieldInputText('email', 'Email', undefined, {
                        isDisabled: true,
                        validatorOrOpts: [Validators.required],
                    }),
                    e11FieldInputText('displayName', 'Display Name', undefined, {
                        isHidden: !this.includeDisplayName,
                        validatorOrOpts: displayNameValidators,
                    }),
                ]),
            ], {
                templateSpec: { templateKey: 'personal-header', templatePosition: 'top' },
            }),
            e11LayoutGroup([...this.addressFormService.formGroup()], {
                templateSpec: { templateKey: 'location-header', templatePosition: 'top' },
            }),
        ]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManagePersonalAccountComponent, deps: [{ token: i3$1.BaseLocalStorageService }, { token: i2.E11NotificationsService }, { token: IUserService }, { token: FormCustomValidationService }, { token: i5$1.AddressFormService }, { token: LOGGER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ManagePersonalAccountComponent, selector: "sdk-manage-personal-account", inputs: { includeDisplayName: "includeDisplayName" }, providers: [AddressFormService], viewQueries: [{ propertyName: "_formBuilder", first: true, predicate: ["userFormBuilder"], descendants: true }], ngImport: i0, template: "<e11-panel>\n  <div class=\"e11-w-full e11-flex e11-flex-col\">\n    <div>\n      <e11-dynamic-form-builder\n        [loading]=\"!user\"\n        [hideSubmitMenu]=\"true\"\n        #userFormBuilder\n        class=\"e11-w-full\"\n        [fieldGroups]=\"fieldGroup\"\n        [initialValue]=\"user\"\n      >\n        <ng-template e11Template=\"personal-header\">\n          <h3 class=\"e11-col-span-full e11-mb-4\">{{ \"Personal Information\" | translate }}</h3>\n        </ng-template>\n        <ng-template e11Template=\"location-header\">\n          <h3 class=\"e11-col-span-full e11-mb-4\">{{ \"Location\" | translate }}</h3>\n        </ng-template>\n      </e11-dynamic-form-builder>\n    </div>\n\n    <div class=\"e11-mt-5\">\n      <div class=\"e11-text-center\">\n        <e11-button (click)=\"onSubmitFormAccount()\" value=\"{{ 'Save' | translate }}\" color=\"primary-accent\"></e11-button>\n      </div>\n    </div>\n  </div>\n</e11-panel>\n", styles: [""], dependencies: [{ kind: "component", type: i6.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i3.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i8$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "directive", type: i9$1.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManagePersonalAccountComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-manage-personal-account', providers: [AddressFormService], template: "<e11-panel>\n  <div class=\"e11-w-full e11-flex e11-flex-col\">\n    <div>\n      <e11-dynamic-form-builder\n        [loading]=\"!user\"\n        [hideSubmitMenu]=\"true\"\n        #userFormBuilder\n        class=\"e11-w-full\"\n        [fieldGroups]=\"fieldGroup\"\n        [initialValue]=\"user\"\n      >\n        <ng-template e11Template=\"personal-header\">\n          <h3 class=\"e11-col-span-full e11-mb-4\">{{ \"Personal Information\" | translate }}</h3>\n        </ng-template>\n        <ng-template e11Template=\"location-header\">\n          <h3 class=\"e11-col-span-full e11-mb-4\">{{ \"Location\" | translate }}</h3>\n        </ng-template>\n      </e11-dynamic-form-builder>\n    </div>\n\n    <div class=\"e11-mt-5\">\n      <div class=\"e11-text-center\">\n        <e11-button (click)=\"onSubmitFormAccount()\" value=\"{{ 'Save' | translate }}\" color=\"primary-accent\"></e11-button>\n      </div>\n    </div>\n  </div>\n</e11-panel>\n" }]
        }], ctorParameters: () => [{ type: i3$1.BaseLocalStorageService }, { type: i2.E11NotificationsService }, { type: IUserService }, { type: FormCustomValidationService }, { type: i5$1.AddressFormService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }], propDecorators: { _formBuilder: [{
                type: ViewChild,
                args: ['userFormBuilder']
            }], includeDisplayName: [{
                type: Input
            }] } });

const ABOUT_ME_MAX_LENGTH = 140;
class SocialFormComponent {
    constructor(formBuilder, notificationService) {
        this.formBuilder = formBuilder;
        this.notificationService = notificationService;
        this.socialDataUpdated = new EventEmitter();
        this.maxLengthAboutMe = ABOUT_ME_MAX_LENGTH;
        this.socialForm = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.isMobile = false;
    }
    ngOnInit() {
        this.initFormGroup(this.socialData);
    }
    onSubmitForm() {
        if (this.socialForm.valid) {
            const socialData = this.socialForm.value;
            this.socialDataUpdated.emit(socialData);
            this.activateNotification();
        }
    }
    get f() {
        return this.socialForm.controls;
    }
    initFormGroup(data) {
        const formInput = {
            aboutMe: new FormControl(data?.aboutMe, [E11FormValidator.minLengthAlphanumeric(1)]),
        };
        this.socialForm = this.formBuilder.group(formInput);
    }
    activateNotification() {
        const message = {
            title: 'Good work!',
            message: 'Your information has been saved.',
            type: 'success',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationService.popNotificationMessage(message);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SocialFormComponent, deps: [{ token: i1$3.FormBuilder }, { token: i2.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: SocialFormComponent, selector: "sdk-social-form", inputs: { socialData: "socialData" }, outputs: { socialDataUpdated: "socialDataUpdated" }, ngImport: i0, template: `
    <form [formGroup]="socialForm" (ngSubmit)="onSubmitForm()">
      <e11-textarea
        [label]="'About Me' | translate"
        formControlName="aboutMe"
        name="aboutMe"
        [parentForm]="socialForm"
        [darkMode]="false"
        [maxlength]="maxLengthAboutMe"
        [rows]="2"
      >
        <e11-input-errors [parentForm]="socialForm" [formControl]="f.aboutMe" label="{{ 'About Me' | translate }}"></e11-input-errors>
      </e11-textarea>
      <e11-button type="submit" [size]="!isMobile ? 'md' : 'sm'" [color]="'primary-accent'" [value]="'Save' | translate"> </e11-button>
    </form>
  `, isInline: true, dependencies: [{ kind: "component", type: i6.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i4$3.E11TextareaComponent, selector: "e11-textarea", inputs: ["name", "id", "cols", "rows", "label", "required", "labelColor", "borderGlow", "readonly", "disabled", "disabledText", "hasError", "parentForm", "placeholder", "darkMode", "maxLength", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "formControlName", "containerClass", "inputClass", "loading", "tooltipConfig", "labelTextOptional"], outputs: ["change", "focus", "blur"] }, { kind: "directive", type: i1$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i11.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SocialFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-social-form',
                    template: `
    <form [formGroup]="socialForm" (ngSubmit)="onSubmitForm()">
      <e11-textarea
        [label]="'About Me' | translate"
        formControlName="aboutMe"
        name="aboutMe"
        [parentForm]="socialForm"
        [darkMode]="false"
        [maxlength]="maxLengthAboutMe"
        [rows]="2"
      >
        <e11-input-errors [parentForm]="socialForm" [formControl]="f.aboutMe" label="{{ 'About Me' | translate }}"></e11-input-errors>
      </e11-textarea>
      <e11-button type="submit" [size]="!isMobile ? 'md' : 'sm'" [color]="'primary-accent'" [value]="'Save' | translate"> </e11-button>
    </form>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.FormBuilder }, { type: i2.E11NotificationsService }], propDecorators: { socialData: [{
                type: Input
            }], socialDataUpdated: [{
                type: Output
            }] } });

class TermsOfUseComponent {
    /**
     *Creates an instance of TermsOfUseComponent.
     * @param {Router} router
     * @param {FormBuilder} formBuilder
     * @param {UserService} userService
     * @memberof TermsOfUseComponent
     */
    constructor(formBuilder, userService, termsService, _sanitizer) {
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.termsService = termsService;
        this._sanitizer = _sanitizer;
        this.formTerms = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.formTermsSubmitted = false;
        this.loading = false;
        this.onSubmit = new EventEmitter();
        this.onDecline = new EventEmitter();
    }
    /**
     *
     *
     * @memberof TermsOfUseComponent
     */
    ngOnInit() {
        this.formTerms = this.formBuilder.group({
            agreement: [false, Validators.requiredTrue],
        });
        this.termsService.getMostRecentTerms().subscribe((termsModels) => {
            this.termsModel = termsModels[0];
            this.termsOfUse = this._sanitizer.bypassSecurityTrustHtml(termsModels[0].terms);
        });
    }
    /**
     *
     *
     * @readonly
     * @memberof TermsOfUseComponent
     */
    get f() {
        return this.formTerms.controls;
    }
    /**
     *
     *
     * @memberof AuthenticationTermsComponent
     */
    onDeclineAction() {
        this.onDecline.emit(true);
    }
    /**
     *
     *
     * @memberof AuthenticationTermsComponent
     */
    async onAcceptAction() {
        this.formTermsSubmitted = true;
        if (this.formTerms.valid) {
            try {
                this.loading = true;
                if (!this.userId || !this.termsModel?.version) {
                    throw new Error(`userID is undefined or cannot determine terms version userId: ${this.userId} termsVersion: ${this.termsModel?.version}`);
                }
                const user = await this.userService.getUserById(this.userId).toPromise();
                if (user) {
                    user.termsVersionAccepted = this.termsModel.version;
                    await this.userService.update(user);
                    this.loading = false;
                    this.onSubmit.emit(JSON.stringify(user));
                }
            }
            catch (error) {
                this.loading = false;
                throw new Error(error);
            }
        }
        else {
            this.formTerms.controls.agreement.setErrors({ unacceptedTerms: true });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsOfUseComponent, deps: [{ token: i1$3.FormBuilder }, { token: UserService }, { token: ITermsService }, { token: i4$4.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: TermsOfUseComponent, selector: "sdk-terms-of-use", inputs: { userId: "userId" }, outputs: { onSubmit: "onSubmit", onDecline: "onDecline" }, ngImport: i0, template: "<form class=\"e11-mb-4\" [formGroup]=\"formTerms\" (ngSubmit)=\"onAcceptAction()\" novalidate>\n  <div class=\"term-container e11-w-full e11-border e11-border-skin-app-borders e11-p-6 e11-mb-8\">\n    <p class=\"terms-of-use\" [innerHTML]=\"termsOfUse\"></p>\n  </div>\n\n  <div class=\"e11-w-full e11-pb-8\">\n    <e11-input-checkbox\n      [disabled]=\"loading\"\n      color=\"secondary\"\n      [ring]=\"true\"\n      label=\"{{ 'I have reviewed and accept the terms of use.' | translate }}\"\n      formControlName=\"agreement\"\n      name=\"agreement\"\n      id=\"agreement_formTerms\"\n    >\n    </e11-input-checkbox>\n\n    <e11-input-errors\n      [parentForm]=\"formTerms\"\n      [formControl]=\"f.agreement\"\n      [formSubmitted]=\"formTermsSubmitted\"\n      label=\"{{ 'First Name' | translate }}\"\n    >\n    </e11-input-errors>\n  </div>\n\n  <div class=\"e11-w-full e11-text-center\">\n    <e11-button\n      id=\"submit_formTermsDecline\"\n      value=\"{{ 'Decline' | translate }}\"\n      [color]=\"'secondary'\"\n      [type]=\"'button'\"\n      (click)=\"onDeclineAction()\"\n      [buttonGroup]=\"true\"\n    ></e11-button>\n    <e11-button\n      id=\"submit_formTermsAccept\"\n      value=\"{{ loading ? 'Loading...' : ('Submit' | translate) }}\"\n      [color]=\"'primary-accent'\"\n      [type]=\"'submit'\"\n    >\n    </e11-button>\n  </div>\n</form>\n", styles: [".term-container{height:40vh;overflow-y:scroll}\n"], dependencies: [{ kind: "component", type: i6.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i6$1.E11CheckboxComponent, selector: "e11-input-checkbox", inputs: ["name", "size", "color", "fontColor", "ring", "inputClass", "containerClass", "label", "display", "description", "descriptionClassOverrides", "checked", "checkboxPosition", "disabled", "disabledText", "containerClassOverrides", "labelClassOverrides", "loading", "e11CheckboxProps"] }, { kind: "directive", type: i1$3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i11.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i12.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TermsOfUseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-terms-of-use', template: "<form class=\"e11-mb-4\" [formGroup]=\"formTerms\" (ngSubmit)=\"onAcceptAction()\" novalidate>\n  <div class=\"term-container e11-w-full e11-border e11-border-skin-app-borders e11-p-6 e11-mb-8\">\n    <p class=\"terms-of-use\" [innerHTML]=\"termsOfUse\"></p>\n  </div>\n\n  <div class=\"e11-w-full e11-pb-8\">\n    <e11-input-checkbox\n      [disabled]=\"loading\"\n      color=\"secondary\"\n      [ring]=\"true\"\n      label=\"{{ 'I have reviewed and accept the terms of use.' | translate }}\"\n      formControlName=\"agreement\"\n      name=\"agreement\"\n      id=\"agreement_formTerms\"\n    >\n    </e11-input-checkbox>\n\n    <e11-input-errors\n      [parentForm]=\"formTerms\"\n      [formControl]=\"f.agreement\"\n      [formSubmitted]=\"formTermsSubmitted\"\n      label=\"{{ 'First Name' | translate }}\"\n    >\n    </e11-input-errors>\n  </div>\n\n  <div class=\"e11-w-full e11-text-center\">\n    <e11-button\n      id=\"submit_formTermsDecline\"\n      value=\"{{ 'Decline' | translate }}\"\n      [color]=\"'secondary'\"\n      [type]=\"'button'\"\n      (click)=\"onDeclineAction()\"\n      [buttonGroup]=\"true\"\n    ></e11-button>\n    <e11-button\n      id=\"submit_formTermsAccept\"\n      value=\"{{ loading ? 'Loading...' : ('Submit' | translate) }}\"\n      [color]=\"'primary-accent'\"\n      [type]=\"'submit'\"\n    >\n    </e11-button>\n  </div>\n</form>\n", styles: [".term-container{height:40vh;overflow-y:scroll}\n"] }]
        }], ctorParameters: () => [{ type: i1$3.FormBuilder }, { type: UserService }, { type: ITermsService }, { type: i4$4.DomSanitizer }], propDecorators: { userId: [{
                type: Input
            }], onSubmit: [{
                type: Output
            }], onDecline: [{
                type: Output
            }] } });

var UserActionTypes;
(function (UserActionTypes) {
    UserActionTypes["onInitUser"] = "[User Initial App Load] on init";
    UserActionTypes["onInitUserSuccess"] = "[User Initial App Load] on init success";
    UserActionTypes["onIdTokenChanged"] = "[User] on Id token changed";
    UserActionTypes["onUserDocumentChanged"] = "[User] on user document changed";
    UserActionTypes["updateUserPhoto"] = "[User] update user photo";
    UserActionTypes["updateUser"] = "[User] update user";
    UserActionTypes["updateUserSuccess"] = "[User Effects] update user success";
    UserActionTypes["logIn"] = "[User From Component] on login";
    UserActionTypes["logInSuccess"] = "[User From Effect] on login success";
    UserActionTypes["logOut"] = "[User] on logout";
    UserActionTypes["logOutSuccess"] = "[User] on logout success";
    UserActionTypes["onRegistration"] = "[Password create page] on registration";
    UserActionTypes["onRegistrationSuccess"] = "[User effects] on registration success";
    UserActionTypes["reset"] = "[User] search users reset";
    UserActionTypes["error"] = "[User] error";
    UserActionTypes["noAction"] = "[User] no action";
})(UserActionTypes || (UserActionTypes = {}));
const OnInitUser = createAction(UserActionTypes.onInitUser, props());
const OnInitUserSuccess = createAction(UserActionTypes.onInitUserSuccess, props());
const OnIdTokenChanged = createAction(UserActionTypes.onIdTokenChanged, props());
const OnUserDocumentChanged = createAction(UserActionTypes.onUserDocumentChanged, props());
const UpdateUser = createAction(UserActionTypes.updateUser, props());
const UpdateUserPhoto = createAction(UserActionTypes.updateUserPhoto, props());
const OnRegistration = createAction(UserActionTypes.onRegistration, props());
const OnRegistrationSuccess = createAction(UserActionTypes.onRegistrationSuccess);
const OnLogIn = createAction(UserActionTypes.logIn, props());
const OnLogInSuccess = createAction(UserActionTypes.logInSuccess, props());
const OnLogOut = createAction(UserActionTypes.logOut);
const OnLogOutSuccess = createAction(UserActionTypes.logOutSuccess, props());
const Reset = createAction(UserActionTypes.reset, props());
const ErrorAction = createAction(UserActionTypes.error, props());
const NoAction = createAction(UserActionTypes.noAction, props());

var user_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ErrorAction: ErrorAction,
    NoAction: NoAction,
    OnIdTokenChanged: OnIdTokenChanged,
    OnInitUser: OnInitUser,
    OnInitUserSuccess: OnInitUserSuccess,
    OnLogIn: OnLogIn,
    OnLogInSuccess: OnLogInSuccess,
    OnLogOut: OnLogOut,
    OnLogOutSuccess: OnLogOutSuccess,
    OnRegistration: OnRegistration,
    OnRegistrationSuccess: OnRegistrationSuccess,
    OnUserDocumentChanged: OnUserDocumentChanged,
    Reset: Reset,
    UpdateUser: UpdateUser,
    UpdateUserPhoto: UpdateUserPhoto,
    get UserActionTypes () { return UserActionTypes; }
});

class LocalStorageService extends BaseLocalStorageService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocalStorageService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocalStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class SessionStorageService extends BaseSessionStorageService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SessionStorageService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SessionStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SessionStorageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class UserEffects {
    constructor(actions$, localStorage, cookieStorage, userConfigProvider, 
    //private authService: IAuthService,
    userService, sessionStorageService, logger, router, errorTracker) {
        this.actions$ = actions$;
        this.localStorage = localStorage;
        this.cookieStorage = cookieStorage;
        this.userConfigProvider = userConfigProvider;
        this.userService = userService;
        this.sessionStorageService = sessionStorageService;
        this.logger = logger;
        this.router = router;
        this.errorTracker = errorTracker;
        this.authService = this.userConfigProvider.authService;
        this.onInit$ = createEffect(() => {
            return this.actions$.pipe(ofType(OnInitUser), mergeMap$1((action) => this.authService.onIdTokenChange().pipe(map$1((token) => OnIdTokenChanged({ token })))));
        });
        this.onInitUserDocument$ = createEffect(() => this.actions$.pipe(ofType(OnInitUser), mergeMap$1((action) => {
            return this.authService.onAuthStateChanged().pipe(mergeMap$1((user) => {
                return from(user.getIdTokenResult()).pipe(map$1((claim) => OnInitUserSuccess(claim.claims)));
            }));
        })));
        this.onInitSuccess$ = createEffect(() => this.actions$.pipe(ofType(OnInitUserSuccess), mergeMap$1((action) => {
            if (action.appUserId) {
                return this.userService.getUserByIdValueChange(action.appUserId).pipe(tap((response) => {
                    // this will kick the user out if it is disabled remotely
                    if (response && response.isDisabled) {
                        this.authService.signOut();
                    }
                }), map$1((response) => {
                    const user = response ? response : null;
                    return OnUserDocumentChanged({ user });
                }), catchError((error) => of(ErrorAction(error))));
            }
            else {
                return of(NoAction({}));
            }
        })));
        this.onIdTokenChanged$ = createEffect(() => this.actions$.pipe(ofType(OnIdTokenChanged), tap(({ token }) => {
            this.localStorage.setItem('token', token);
            this.cookieStorage.setCookie({
                name: 'token',
                value: token,
                expireDays: 30,
                secure: true,
            });
        })), { dispatch: false });
        this.onUserDocumentChanged$ = createEffect(() => this.actions$.pipe(ofType(OnUserDocumentChanged), tap((payload) => this.localStorage.setItem('user', payload.user || undefined))), { dispatch: false });
        this.onUserIdChangedConfigureErrorTracker$ = createEffect(() => this.actions$.pipe(ofType(OnUserDocumentChanged), map$1((payload) => payload.user?.id), distinctUntilChanged(), // only call when the ID changes
        tap((userId) => {
            // Needed for type safety and ensure we are using rollbar
            if (this.errorTracker instanceof Rollbar) {
                // casting as any to allow unsetting person see: https://docs.rollbar.com/docs/javascript#usage
                this.errorTracker.configure({ payload: { person: { id: userId ?? null } } });
            }
        })), { dispatch: false });
        this.onUpdateUser$ = createEffect(() => this.actions$.pipe(ofType(UpdateUser), switchMap((payload) => this.userService.update(payload))), { dispatch: false });
        this.onUpdateUserPhoto$ = createEffect(() => this.actions$.pipe(ofType(UpdateUserPhoto), 
        // @ts-expect-error need to update user model so users can remove profile photos when desired
        switchMap((payload) => this.userService.update(payload))), { dispatch: false });
        this.onRegistration$ = createEffect(() => this.actions$.pipe(ofType(OnRegistration), map$1((payload) => {
            const referrerId = payload.queryParams['referrerId'] ?? this.sessionStorageService.getItem('referrerId');
            if (referrerId) {
                this.logger.log('Adding referrerId: ', referrerId);
                return UpdateUser({ id: payload.appUserId, originSource: referrerId });
            }
            return NoAction({});
        })
        // map(response => new OnRegistrationSuccess())
        ));
        this.onLogIn$ = createEffect(() => this.actions$.pipe(ofType(OnLogIn), mergeMap$1((payload) => {
            this.localStorage.setItem('token', payload.token);
            return this.userService.getUserById(payload.appUserId).pipe(map$1((response) => {
                this.localStorage.setItem('user', response);
                if (response) {
                    return OnLogInSuccess({ currentUser: response, redirectPath: payload.redirectPath });
                }
                else {
                    return ErrorAction(response);
                }
            }), catchError((error) => of(ErrorAction(error))));
        })));
        this.loginSuccess$ = createEffect(() => this.actions$.pipe(ofType(OnLogInSuccess), mergeMap$1((payload) => {
            if (payload.currentUser.userType === UserType.Consumer) {
                this.router.navigate([payload.redirectPath || 'home']);
            }
            else {
                this.router.navigate([payload.redirectPath || 'home']);
            }
            return of(true);
        })), { dispatch: false });
        this.onLogOut$ = createEffect(() => this.actions$.pipe(ofType(OnLogOut), mergeMap$1((action) => {
            this.localStorage.clear();
            this.sessionStorageService.clear();
            this.localStorage.clear();
            this.cookieStorage.deleteCookie('token');
            return of(this.authService.signOut()).pipe(map$1(() => OnLogOutSuccess({ payload: true })), catchError((error) => of(ErrorAction(error))));
        })));
    }
    ngrxOnInitEffects() {
        return { type: OnInitUser.type };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserEffects, deps: [{ token: i1$6.Actions }, { token: LocalStorageService }, { token: i3$1.CookieService }, { token: BaseUserConfigProvider }, { token: IUserService }, { token: SessionStorageService }, { token: i1$2.E11Logger }, { token: i8$2.Router }, { token: ERROR_TRACKER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$6.Actions }, { type: LocalStorageService }, { type: i3$1.CookieService }, { type: BaseUserConfigProvider }, { type: IUserService }, { type: SessionStorageService }, { type: i1$2.E11Logger }, { type: i8$2.Router }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ERROR_TRACKER_TOKEN]
                }] }] });

var user_effects = /*#__PURE__*/Object.freeze({
    __proto__: null,
    UserEffects: UserEffects
});

const adapter = createEntityAdapter();
const initialState = adapter.getInitialState({
    loaded: false,
    loading: false,
    error: null,
    currentUser: null,
    token: null,
});
const reducer$1 = createReducer(initialState, on(OnInitUser, OnLogOut, OnLogIn, (state) => ({
    ...state,
    loading: true,
})), on(OnLogInSuccess, (state, payload) => ({
    ...state,
    currentUser: payload?.currentUser,
})), on(OnUserDocumentChanged, (state, payload) => ({
    ...state,
    currentUser: payload.user,
})), on(OnIdTokenChanged, (state, { token }) => ({
    ...state,
    token,
})), on(OnLogOutSuccess, (state) => ({
    ...state,
    currentUser: null,
})));
const userEntitySelectors = adapter.getSelectors();

var user_reducer = /*#__PURE__*/Object.freeze({
    __proto__: null,
    adapter: adapter,
    initialState: initialState,
    reducer: reducer$1,
    userEntitySelectors: userEntitySelectors
});

/**
 * Ensures user is a consumer, else throws an error
 * Should remain internal to store
 * @param user
 * @returns
 */
const _consumerOrError = (user) => {
    if (!user) {
        return null;
    }
    if (user.userType === UserType.Consumer) {
        return user;
    }
    throw new Error(`User must be of type consumer, but is of type ${user.userType}`);
};
/**
 * Ensures user is a business user, else throws an error
 * Should remain internal to store
 * @param user
 * @returns
 */
const _businessUserOrError = (user) => {
    if (!user) {
        return null;
    }
    if (user.userType === UserType.Business) {
        return user;
    }
    throw new Error(`User must be of type business, but is of type ${user.userType}`);
};

const userFeature = createFeature({
    name: 'user',
    reducer: reducer$1,
    extraSelectors: ({ selectToken, selectUserState, selectCurrentUser }) => {
        const getToken = createSelector(selectToken, (token) => token);
        const getCurrentUser = createSelector(selectCurrentUser, (user) => user);
        const getCurrentToken = createSelector(selectUserState, (store) => store.token);
        const getUserEntities = createSelector(selectUserState, userEntitySelectors.selectAll);
        const getCustomerKey = createSelector(selectUserState, (store) => store.currentUser != null && store.currentUser.customerKey);
        const getCurrentTokenDecoded = createSelector(getCurrentToken, (token) => (token ? jwt_decode(token) : null));
        const getCurrentUserConsumer = createSelector(selectCurrentUser, (user) => _consumerOrError(user));
        const getCurrentUserEmployer = createSelector(selectCurrentUser, (user) => _businessUserOrError(user));
        const getCurrentUserId = createSelector(selectCurrentUser, (user) => user?.id);
        const getCustomerKey$ = createSelector(selectCurrentUser, (user) => user?.customerKey);
        const getIsEmailVerified = createSelector(getCurrentTokenDecoded, (token) => token?.email_verified);
        return {
            getToken,
            getCurrentUser,
            getCurrentToken,
            getUserEntities,
            getCustomerKey,
            getCurrentTokenDecoded,
            getCurrentUserConsumer,
            getCurrentUserEmployer,
            getCurrentUserId,
            getCustomerKey$, //not to be confused with selectCustomerKey
            getIsEmailVerified,
        };
    },
});

var user_selectors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    userFeature: userFeature
});

const { name, reducer, ...userSelectors } = userFeature;

const ImportExportModules = [E11ButtonModule, E11InputCheckboxModule, E11TextareaModule, E11ConfirmationModule];
class UiComponentLibraryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, imports: [CommonModule, E11ButtonModule, E11InputCheckboxModule, E11TextareaModule, E11ConfirmationModule], exports: [E11ButtonModule, E11InputCheckboxModule, E11TextareaModule, E11ConfirmationModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, imports: [CommonModule, ImportExportModules, E11ButtonModule, E11InputCheckboxModule, E11TextareaModule, E11ConfirmationModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule, ...ImportExportModules],
                    exports: [...ImportExportModules],
                }]
        }] });

const DeclareExportComponents = [
    SocialFormComponent,
    ManagePersonalAccountComponent,
    TermsOfUseComponent,
    UserSearchComponent,
    BusinessUserEditComponent,
    ManageBusinessUsersComponent,
    RolesDisplayPipe,
    AccountManageNotificationsComponent,
];
class UserModule {
    static forRoot(rootConfig) {
        return {
            ngModule: UserModule,
            providers: [
                {
                    provide: BaseUserConfigProvider,
                    useClass: rootConfig.configProvider,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: UserModule, declarations: [SocialFormComponent,
            ManagePersonalAccountComponent,
            TermsOfUseComponent,
            UserSearchComponent,
            BusinessUserEditComponent,
            ManageBusinessUsersComponent,
            RolesDisplayPipe,
            AccountManageNotificationsComponent, RefreshComponent, UserListComponent, UserEntryComponent], imports: [UiComponentLibraryModule,
            LetDirective,
            CommonModule,
            ReactiveFormsModule,
            TranslateModule,
            E11InputModule,
            E11LoaderDotsModule,
            E11SelectModule,
            E11NotificationsModule,
            E11MultiSelectModule,
            E11PanelModule,
            E11EmptyStateModule,
            E11PhoneNumberModule,
            E11DynamicFormModule,
            E11PanelModule,
            E11SwitchModule, i4$2.NgAisRootModule, i4$2.NgAisInstantSearchModule, NgAisHitsModule,
            WebUtilityModule,
            NgAisSearchBoxModule, i11.E11InputErrorsModule, ViewAddressComponent], exports: [SocialFormComponent,
            ManagePersonalAccountComponent,
            TermsOfUseComponent,
            UserSearchComponent,
            BusinessUserEditComponent,
            ManageBusinessUsersComponent,
            RolesDisplayPipe,
            AccountManageNotificationsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserModule, providers: [
            PrivacyPolicyService,
            { provide: IUserService, useClass: UserService },
            {
                provide: ITermsService,
                useClass: TermsService,
            },
        ], imports: [UiComponentLibraryModule,
            CommonModule,
            ReactiveFormsModule,
            TranslateModule,
            E11InputModule,
            E11LoaderDotsModule,
            E11SelectModule,
            E11NotificationsModule,
            E11MultiSelectModule,
            E11PanelModule,
            E11EmptyStateModule,
            E11PhoneNumberModule,
            E11DynamicFormModule,
            E11PanelModule,
            E11SwitchModule,
            NgAisModule.forRoot(),
            NgAisInstantSearchModule.forRoot(),
            NgAisHitsModule,
            WebUtilityModule,
            NgAisSearchBoxModule,
            E11InputErrorsModule.forRoot({
                additional: {
                    phoneNumber: 'Please enter a valid phone number',
                    invalidDate: 'Please enter a valid date',
                    invalidStartDate: 'Must be before end date',
                    invalidEndDate: 'Must be after start date',
                    DateFuture: 'Must be in the past', // TODO consider how to get static type checking on these
                    unacceptedTerms: 'You must accept the terms before you can continue.',
                    hasAlphaNumericError: 'Only letters and numbers are allowed here',
                },
            }),
            ViewAddressComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents, RefreshComponent, UserListComponent, UserEntryComponent],
                    imports: [
                        UiComponentLibraryModule,
                        LetDirective,
                        CommonModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        E11InputModule,
                        E11LoaderDotsModule,
                        E11SelectModule,
                        E11NotificationsModule,
                        E11MultiSelectModule,
                        E11PanelModule,
                        E11EmptyStateModule,
                        E11PhoneNumberModule,
                        E11DynamicFormModule,
                        E11PanelModule,
                        E11SwitchModule,
                        NgAisModule.forRoot(),
                        NgAisInstantSearchModule.forRoot(),
                        NgAisHitsModule,
                        WebUtilityModule,
                        NgAisSearchBoxModule,
                        E11InputErrorsModule.forRoot({
                            additional: {
                                phoneNumber: 'Please enter a valid phone number',
                                invalidDate: 'Please enter a valid date',
                                invalidStartDate: 'Must be before end date',
                                invalidEndDate: 'Must be after start date',
                                DateFuture: 'Must be in the past', // TODO consider how to get static type checking on these
                                unacceptedTerms: 'You must accept the terms before you can continue.',
                                hasAlphaNumericError: 'Only letters and numbers are allowed here',
                            },
                        }),
                        ViewAddressComponent,
                    ],
                    providers: [
                        PrivacyPolicyService,
                        { provide: IUserService, useClass: UserService },
                        {
                            provide: ITermsService,
                            useClass: TermsService,
                        },
                    ],
                    exports: [...DeclareExportComponents],
                }]
        }] });

/*
 * Public API Surface of user
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountManageNotificationsComponent, BaseUserConfigProvider, BusinessUserEditComponent, BusinessUserManagementRestService, COLLECTIONS, CONSTANTS, ERROR_HANDLING, ErrorAction, ITermsService, IUserRestService, IUserService, ManageBusinessUsersComponent, ManagePersonalAccountComponent, NoAction, OnIdTokenChanged, OnInitUser, OnInitUserSuccess, OnLogIn, OnLogInSuccess, OnLogOut, OnLogOutSuccess, OnRegistration, OnRegistrationSuccess, OnUserDocumentChanged, PlatformAdminUserRestService, PrivacyPolicyService, RefreshComponent, Reset, RolesDisplayPipe, SEARCH_INDICES, SocialFormComponent, TermsOfUseComponent, TermsService, USER_FILTERS, UpdateUser, UpdateUserPhoto, UserActionTypes, UserModule, UserPermissions, UserPreferencesService, UserRestService, UserSearchComponent, UserService, user_actions as userActions, user_effects as userEffects, user_selectors as userFeature, user_reducer as userReducer, userSelectors };
